import cargo from "./cargo/en";

export default {
  "STT Sudah Di Scan": "STT Already Scanned",
  "Semua waktu": "All time",
  urgentRelabel: {
    searchPlaceholder: "Search STT no.",
    download: "Download",
    printAll: "Print all receipts",
    printSize: "Print Size {size}",
    column: {
      no: "No",
      sttNo: "STT No.",
      shipmentType: "Shipment type",
      rootSttNo: "Origin STT No.",
      processedBy: "Processed by",
      overtimeDuration: "Overtime duration",
      overtimeDurationDays: "{day} days",
      bkdDate: "BKD Date",
      originCity: "Origin city",
      destinationCity: "Destination city",
      printReceipt: "Print Receipt"
    },
    empty: {
      header: "No Relabel Monitor STT yet",
      message:
        "STT from HAL Reroute awaiting Relabel will appear here."
    },
    filter: {
      title: "Filter",
      processedBy: "Processed by",
      processedByPlaceholder: "Select processed by",
      shipmentType: "Shipment type",
      shipmentTypePlaceholder: "Select shipment type",
      originCity: "Origin city",
      originCityPlaceholder: "Select origin city",
      destinationCity: "Destination city",
      destinationCityPlaceholder: "Select destination city",
      bkdUpdateDate: "BKD update date",
      reset: "Reset",
      apply: "Apply",
      optionClient: "Client",
      optionConsolidator: "Consolidator",
      allProducts: "All Products",
      productCount: "{count} Products"
    },
    cityFilter: {
      defaultTitle: "City",
      defaultPlaceholder: "Select city",
      locationCount: "{count} Locations"
    }
  },
  "COD International Client": "COD International Client",
  bookingSdn: {
    notice: "This route may experience delivery delays, but you can still proceed with booking."
  },
  loading: "Your Request is In Progress",
  uploadFile: {
    loading: "Loading...",
    clickToUpload: "Click to upload",
    orDragAndDrop: "or drag and drop"
  },
  "STT Paid/Unpaid": "STT Paid/Unpaid",
  "STT Kurang Bayar": "STT Paid/Unpaid",
  "Permintaan Gagal !": "Request Failed !",
  "Simpan Perubahan": "Save Changes",
  "Pos pembooking": "Booking POS",
  bagging: {
    editDimensionInfo: "Edit if dimension changes",
    volumeWeightBag: "Bag volume weight",
    chargeableWeightBag: "Chargeable bag weight",
    errorBagExceed: "Bag weight exceeds STT weight."
  },
  "Pilih POS": "Select POS",
  parsingErrorSpec: {
    rateNotFoundHeader: "Shipment Rates Not Found",
    rateNotFoundMessage:
      "Shipment rates for the selected route are not available",
    embargoHeader: "Route Under Embargo!",
    embargoMessage:
      "Unable to process your request. Please reset your route",
    balanceBelowHeader: "Your Balance Is Below the Limit!",
    balanceBelowMessage:
      "Top up your balance now. Ensure your balance is sufficient before shipping activities.",
    posBalanceHeader: "Insufficient POS Balance",
    posBalanceMessage:
      "Please contact POS to top up balance for address changes.",
    requestFailedHeader: "Request Failed !",
    updateFailedHeader: "Update Failed!",
    okUnderstand: "OK, I Understand"
  },
  sidebar: {
    currentVersion: "Current version.",
    revertToPreviousVersion: "Revert to previous version",
    searchMenuPlaceholder: "Search menu",
    menuNotFound: "Menu not found",
    menuNotFoundDescription: "The menu you are looking for does not exist",
    back: "Back",
    feedback: {
      title: "Give your rating",
      subtitle: "Your feedback is valuable to us",
      subtitleCardReview: "Your feedback is valuable for improvement",
      rateButton: "Rate"
    }
  },
  layout: {
    firebaseNotification: {
      cancel: {
        success: "<b>Cargo No. {cargoNo}</b> cancelled successfully",
        failed:
          "<b>Cargo No. {cargoNo}</b> - Cancellation failed because <b>{reason}</b>."
      },
      booking: {
        success:
          "<b>Cargo No. {cargoNo}</b> cargo booking succeeded to <b>{destination}</b>",
        failed:
          "<b>Cargo No. {cargoNo}</b> booking failed because <b>{reason}</b>"
      }
    }
  },
  managementCustomer: {
    tab: {
      alamat: "Address",
      savedPackage: "Saved packages"
    },
    savedPackage: {
      detailTitle: "Item and package details",
      addButton: "Add saved package",
      empty: "No saved package yet",
      emptyTitle: "No data yet",
      emptyDescription: "No saved package data to display at this time.",
      deleteConfirmTitle: "Confirm delete",
      deleteConfirmMessage: "Are you sure you want to delete this saved package?",
      deleteConfirmSubmit: "Delete data",
      deleteConfirmCancel: "Back",
      koli: "package"
    }
  },
  validation: {
    phone: {
      invalid: "Invalid phone number. Please try again.",
      validMsisdn: "Valid phone number with MSISDN type",
      validPstn: "Valid phone number with PSTN type"
    }
  },
  feedback: {
    modal: {
      title: "Give rating",
      subtitle: "Please give your rating for Genesis",
      ratingHint: "(1 disappointing, 5 very satisfying)",
      rating1: "Disappointing",
      rating2: "Slightly disappointing",
      rating3: "Average",
      rating4: "Satisfying",
      rating5: "Very satisfying",
      reviewLabel: "Give your review",
      reviewPlaceholder: "Share your feedback on using Genesis",
      cancel: "Cancel",
      submit: "Submit",
      successTitle: "Thank you for your rating",
      successMessage: "Lion Parcel will do our best for you",
      successButton: "Done",
      closeConfirmTitle: "You have not given a rating",
      closeConfirmMessage:
        "Please give your rating and review for using the Genesis system",
      closeConfirmCancel: "Exit",
      closeConfirmSubmit: "Give rating"
    }
  },
  dashboard: {
    emptyState: "Oops.. No data to display",
    greeting: "Hi, {name}!",
    lastSync: "Last Data Sync",
    sttNoteBefore: "STT is updated every ",
    sttNoteStrong: "10 minutes",
    sttNoteAfter: " and will appear when cutoff starts",
    codIntro:
      "Below is the total STT you processed in the last 3 days with each status.",
    seeMore: "See More",
    shortcut: {
      menuUtama: "Main Menu",
      bookingRetail: "Retail Booking",
      bookingKlien: "Client Booking",
      bookingShipment: "App & Marketplace Booking",
      bookingInstant: "Instant Booking",
      ppob: "PPOB",
      new: "New"
    },
    console: {
      card: {
        remainingTime: "Remaining time",
        maxTime: "Maximum Time"
      },
      tabs: {
        allStt: "All STT",
        currentStt: "Current STT",
        cod: "COD",
        hangingBkd: "Hanging BKD",
        hangingOutgoing: "Hanging Outgoing",
        hangingIncoming: "Hanging Incoming",
        hangingLastMile: "Hanging Last Mile"
      },
      common: {
        viewDetail: "View Detail",
        downloadXlsx: "Download .xlsx",
        total: "Total"
      },
      allStt: {
        failedToLoad: "Failed to load data",
        incomingStt: "Incoming STT",
        transitStt: "Transit STT",
        outgoingStt: "Outgoing STT",
        loadMore: "Load More",
        cardTitles: {
          sttNotReceived: "STT Not Received",
          sttCargoPlane: "STT Cargo Plane",
          sttCargoTruck: "STT Cargo Truck",
          sttCargoTrain: "STT Cargo Train",
          sttTransit: "STT Transit",
          sttMisroute: "STT Misroute",
          sttShortland: "STT Shortland",
          sttNotFinished: "STT Not Finished",
          sttStiDest: "STT STI-DEST",
          sttStiDestSc: "STT STI DEST-SC",
          sttDel: "STT DEL",
          sttDex: "STT DEX",
          sttHal: "STT HAL",
          sttBkd: "STT BKD",
          sttPup: "STT PUP",
          sttStiSc: "STT STI-SC",
          sttSti: "STT STI",
          sttBagging: "STT Bagging",
          sttRejected: "STT Rejected"
        },
        cardDescriptions: {
          incomingNotReceived: "Total STT that has not arrived at destination city Consolidator",
          incomingCargoPlane: "Total STT to consolidator city with latest status Cargo Plane",
          incomingCargoTruck: "Total STT to consolidator city with latest status Cargo Truck",
          incomingCargoTrain: "Total STT to consolidator city with latest status Cargo Train",
          incomingTransit: "Total STT to consolidator city with latest status Transit",
          incomingMisroute: "Total STT to consolidator city with latest status Misroute",
          incomingShortland: "Total STT to consolidator city with latest status Shortland",
          incomingNotFinished: "Total STT that already arrived at destination city Consolidator but delivery process is not completed",
          incomingStiDest: "Total STT in destination city with latest status STI-DEST",
          incomingStiDestSc: "Total STT in destination city with latest status STI DEST-SC",
          incomingDel: "Total STT in destination city with latest status DEL",
          incomingDex: "Total STT in destination city with latest status DEX",
          incomingHal: "Package is held at destination city Consolidator for several reasons.",
          transitUndelivered: "Total transit STT that has not arrived at transit consolidator",
          transitUndeliveredCargoPlane: "Total STT to transit city with latest status Cargo Plane",
          transitUndeliveredCargoTruck: "Total STT to transit city with latest status Cargo Truck",
          transitUndeliveredCargoTrain: "Total STT to transit city with latest status Cargo Train",
          transitUnfinished: "Total transit STT that has arrived at transit consolidator but delivery process is not completed",
          transitUnfinishedCargoPlane: "Total STT originating from transit Consolidator with latest status Cargo Plane",
          transitUnfinishedCargoTruck: "Total STT originating from transit Consolidator with latest status Cargo Truck",
          transitUnfinishedCargoTrain: "Total STT originating from transit Consolidator with latest status Cargo Train",
          transitUnfinishedTransit: "Total STT in transit city with latest status Transit",
          outgoingNotReceived: "Total STT not yet received by origin city Consolidator",
          outgoingBkd: "Total STT in origin city with latest status BKD",
          outgoingPup: "Total STT in origin city with latest status PUP",
          outgoingStiSc: "Total STT in origin city with latest status STI-SC",
          outgoingNotFinished: "Total STT sent from origin city but not yet arrived at destination city",
          outgoingSti: "Total STT originating from consolidator with latest status STI",
          outgoingBagging: "Total STT originating from consolidator with latest status Bagging",
          outgoingShortland: "Total STT originating from consolidator with latest status Shortland",
          outgoingCargoPlane: "Total STT originating from consolidator with latest status Cargo Plane",
          outgoingCargoTruck: "Total STT originating from consolidator with latest status Cargo Truck",
          outgoingCargoTrain: "Total STT originating from consolidator with latest status Cargo Train",
          outgoingMisroute: "Total STT originating from consolidator with latest status Misroute",
          outgoingRejected: "Package is rejected by cargo team because it does not comply with Cargo Plane regulations"
        }
      },
      currentStt: {
        outgoing: "Outgoing",
        incoming: "Incoming",
        infoTitle: "Information {type}",
        posListTitle: "List of POS that have not sent STT",
        notProcessed: "Not Processed",
        processed: "Processed",
        errorTitle: "Page under maintenance",
        errorMessage: "Sorry, this page is under maintenance. We will be back online soon.",
        whatsappActiveAgainAt: "Active again at",
        andReloadPage: "and reload the page",
        whatsappClickHint: "Click Chat on WhatsApp.",
        whatsappCooldownHint: "You can only contact this POS again after the next 1 hour!",
        clickToDetail: "Click for Detail",
        sortDesc: "Sort from largest to smallest",
        sortAsc: "Sort from smallest to largest",
        table: {
          no: "No",
          posName: "POS Name",
          posCode: "POS Code",
          posPhone: "POS Phone Number",
          unprocessed: "Not Processed",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging"
        },
        cutOffTitles: {
          cycle1: "Cycle 1",
          cycle2: "Cycle 2",
          needSti: "Need at STI",
          needCargoPlane: "Need at Air Cargo",
          needCargoTruckTrain: "Need at Truck/Train Cargo",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging",
          bkdToSti: "BKD to STI",
          stiToCargoPlane: "STI to Air Cargo",
          stiToCargoTruckTrain: "STI to Truck/Train Cargo",
          onTime: "On Time",
          late: "Late",
          invalidSkippingStatus: "Invalid/Skipping Status",
          needDel: "Need at DEL",
          needPod: "Need at POD"
        }
      },
      detailProcess: {
        locationSti: "at STI",
        locationDel: "at DEL",
        locationCargoPlane: "at Air Cargo",
        locationPod: "at POD",
        locationCargoTruckTrain: "at Truck/Train Cargo",
        columns: {
          onTime: "On Time",
          late: "Late",
          invalid: "Invalid",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging"
        },
        tooltips: {
          onTime: "List of STT that has been updated and still within cutoff time",
          late: "List of STT that has been updated outside cutoff time",
          invalid: "List of STT that has been processed but skipped required status",
          backlogToday: "List of STT not processed today and already past cutoff time",
          backlog2to7: "List of STT not processed for 2-7 days and already past cutoff time",
          hanging: "List of STT not updated and already more than 7 days"
        }
      }
    },
    hanging: {
      accountTypePos: "POS",
      accountTypeKonsolidator: "Consolidator",
      historyIncomingTitle: "Incoming Hanging History",
      historyOutgoingTitle: "Outgoing Hanging History",
      historyLastMileTitle: "Last Mile Hanging History",
      historyBkdTitle: "BKD Hanging History",
      historyBkdConsoleTitle: "BKD Console Hanging History",
      historyBkdPosTitle: "BKD Pos Hanging History",
      historyHangingTab: "Hanging History",
      historyFollowUpTab: "Follow Up History"
    }
  },
  cariStt: {
    menuTitle: "Search STT",
    menuName: "Search STT Manifest",
    pageTitle: "Search STT Manifest",
    searchPlaceholder: "Search manifest ID",
    emptyState: "No data available",
    emptyStateDescription:
      "Data will appear here automatically when available.",
    searchNotFound: "Search results not found",
    searchNotFoundDescription: "Please check your keyword or filter.",
    columnNo: "No.",
    columnManifestNo: "No. Manifest",
    columnTotalStt: "Total STT",
    columnTotalKoli: "Total Koli",
    columnTotalSttHanging: "Total STT Hanging",
    columnTanggalManifest: "Manifest Date",
    columnAtur: "Actions",
    scanButton: "Search STT",
    printManifest: "Print Manifest",
    downloadCsv: "Download CSV",
    scanPageTitle: "Search STT",
    scanEmptyState: "No packages scanned yet.",
    errorProcessManifest: "Process Manifest Failed",
    errorFetchList: "Failed to fetch STT data",
    filterSearchPlaceholder: "Search STT no.",
    filterLastStatus: "Last status",
    filterLocation: "Last location",
    processManifestButton: "Process manifest",
    table: {
      hanging: "Hanging",
      nonHanging: "Non-Hanging",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      no: "No.",
      noStt: "No. STT",
      lastLocation: "Last Location",
      lastStatus: "Last Status",
      note: "Note",
      emptyState: "No data available",
      days: "days"
    },
    pdf: {
      title: "Search STT Manifest",
      days: "days",
      partnerName: "Partner name",
      partnerCity: "Partner city",
      totalSttKoli: "Total STT /Pieces",
      totalSttHangingKoli: "Total STT Hanging /Pieces",
      manifestDateHanging: "Hanging manifest date",
      userManifest: "Manifest user",
      noRef: "Ref. no.",
      productType: "Product type",
      lastStatus: "Last Status",
      hanging: "Hanging",
      hangingType: "Hanging Type",
      originCity: "Origin City",
      destCity: "Destination City",
      staffAdmin: "Staff Admin",
      courier: "Courier",
      operationsSupervisor: "Operations Supervisor"
    }
  },
  dispatch: {
    searchPlaceholder: "Search dispatch number",
    createDispatch: "Create dispatch",
    last7Days: "Last 7 days",
    reload: "Reload",
    errorSystem: "System error occurred",
    errorSystemMessage: 'Click "Reload" or try again later.',
    errorInternet: "Internet connection lost",
    errorInternetMessage: 'Check your network then click "Reload".',
    no: "No",
    noDispatch: "Dispatch No.",
    jumlahSttKoli: "STT count (pcs)",
    totalWeight: "Total weight",
    createdAt: "Created at",
    courierShuttle: "Courier/Shuttle",
    atur: "Actions",
    downloadData: "Download data",
    printPdf: "Print PDF",
    filterCreatedBy: "Filter created by",
    all: "All",
    checker: "Checker",
    shuttle: "Shuttle",
    detail: "Detail",
    totalSttKoli: "Total STT (pcs)",
    courier: "Courier",
    courierOrShuttle: "Courier/shuttle",
    dispatchDate: "Dispatch date",
    searchSttDem: "Search STT/DEM number",
    printManifest: "Print manifest",
    jenisPengiriman: "Service type",
    noReferensi: "Ref. No.",
    koli: "pcs",
    ursaCode: "Ursa code",
    noDem: "DEM No.",
    noStt: "STT No.",
    totalBerat: "Total weight",
    dispatchDelivery: "Dispatch delivery",
    manifestSuccess: "Manifest {dispatchNo} created successfully",
    processFailed: "Failed to create manifest",
    totalSttKoliShort: "Total STT/pcs",
    weight: "Weight",
    process: "Process",
    searchPlaceholderUpdate: "Shipment/STT/DEM No.",
    allStatus: "All",
    success: "Success",
    failed: "Failed",
    noPackageDispatch: "No packages dispatched yet",
    sttDemNotFound: "STT/DEM number not found",
    sttDemNotFoundHint: "Check again or search for another STT/DEM number.",
    pdf: {
      consolidatorCity: "Consolidator city",
      manifestDate: "Manifest date",
      createdBy: "Created by",
      totalSttKoli: "Total STT/pcs",
      totalBerat: "Total weight"
    },
    pdfFailed: {
      listTitle: "Failed dispatch list",
      consolidatorName: "Consolidator name",
      consolidatorCity: "Consolidator city",
      createdBy: "Created by",
      unpaid: "Unpaid",
      wrongDestination: "Destination city mismatch",
      wrongStatus: "Status mismatch ({lastStatus})"
    }
  },
  courierManagement: {
    menuTitle: "Courier Management",
    listTitle: "Courier List",
    approvalListTitle: "Courier Approval List",
    addTitle: "Courier Management | Add",
    addCourier: "Add Courier",
    detailTitle: "Courier Management | Detail",
    editTitle: "Courier Management | Edit",
    edit: "Edit",
    editDetailCourier: "Edit courier detail",
    detailParent: "Courier Management Detail",
    tabList: "Courier Management",
    tabApproval: "Courier Approval",
    save: "Save",
    detailCourier: "Courier Detail",
    courierName: "Courier name",
    placeholderCourierName: "Enter courier name",
    phoneLabel: "Phone number",
    courierType: "Courier type",
    announcementCourierType: "Announcement courier type",
    vehicleType: "Vehicle type",
    plateNumber: "Plate number",
    placeholderPlateNumber: "Enter plate number",
    ownershipName: "Ownership name",
    placeholderOwnershipName: "Enter ownership name",
    bank: "Bank",
    bankName: "Bank name",
    codDelivery: "COD delivery available?",
    yes: "Yes",
    cod: "COD",
    yesShort: "YES",
    noShort: "NO",
    accountOwnerName: "Account owner name",
    placeholderAccountOwnerName: "Enter account owner name",
    accountNumber: "Account number",
    placeholderAccountNumber: "Enter account number",
    areaDelivery: "Area Delivery",
    no: "No",
    district: "District",
    select3lc: "Select 3LC",
    searchDistrict: "Search and select district",
    add3lc: "Add another 3LC",
    courierStatus: "Courier status",
    statusToggleHint: "You can activate this status anytime",
    active: "Active",
    inactive: "Inactive",
    connectedDevices: "Connected Devices",
    lastActiveToday: "Last active today",
    lastActiveAt: "Last active",
    delete: "Delete",
    back: "Back",
    cancel: "Cancel",
    posName: "POS Name",
    placeholderPosName: "Enter POS name",
    consolidatorName: "Consolidator Name",
    noAreaDeliveryData: "No area delivery data",
    confirmSaveCourier: "Save courier changes?",
    confirmSaveCourierMessage:
      "Ensure the courier details you changed are correct.",
    courierUpdateSuccess: "Courier updated successfully",
    courierUpdateSuccessMessage:
      "Please check the courier details you updated.",
    checkCourier: "Check Courier",
    confirmDeleteDevice: "Confirm device removal",
    confirmDeleteDeviceMessage:
      "Device <b>{deviceName} ({deviceOs})</b> will no longer be able to access your account unless you sign in again",
    courierCreateSuccess: "Courier added successfully",
    courierCreateSuccessMessage: "Check the courier details you added.",
    failedAddCourier: "Failed to add courier",
    failedEditCourier: "Failed to update courier",
    downloadData: "Download Courier Data",
    searchPlaceholder: "Search name, courier id & phone",
    driverType: "Courier type",
    placeholderDriverType: "Select courier type",
    status: "Status",
    placeholderStatus: "Select status",
    emptyListHeader: "No courier data yet ",
    emptyListMessage: "Add a courier and check the list here.",
    emptyApprovalHeader: "No Courier Data",
    emptyApprovalMessage: "Please add a courier first",
    acceptRequest: "Accept this request?",
    acceptRequestMessage:
      "Courier will still be able to access Lion Parcel Driver app.",
    accept: "Yes, accept",
    rejectRequest: "Reject this request?",
    rejectRequestMessage:
      "Courier will not be able to access Lion Parcel Driver app.",
    reject: "Yes, reject",
    requestSuccess: "Request successfully {action}",
    requestRejected: "rejected",
    requestAccepted: "accepted",
    okGotIt: "OK, got it",
    partnerType: "Partner Type",
    placeholderPartnerType: "Enter Partner Type",
    phonePlaceholder: "812345678901",
    threeLc: "3LC",
    deleteDeviceSuccess: "Device removed successfully",
    deleteDeviceFailed: "Failed to remove device!",
    placeholderAnnouncementCourierType: "Select announcement courier type",
    placeholderVehicleType: "Select vehicle type",
    motorcycle: "Motorcycle",
    truck: "Truck",
    placeholderBank: "Select Bank",
    invalidPhone: "Invalid phone number, please try again",
    invalidPlate: "Invalid plate number, please try again",
    invalidBankAccount: "Invalid bank account number, please try again",
    courierTypeRequired: "Courier type is required",
    console: "Consolidator",
    all: "All"
  },
  chooseHub: "Select HUB",
  chooseSelected: "Selected",
  announcement: {
    menuTitle: "Announcement",
    detailTitle: "Announcement | Detail",
    editTitle: "Announcement | Edit",
    createTitle: "Announcement | Create",
    createName: "Create New Announcement",
    searchPlaceholder: "Search activity name",
    buttonCreate: "Create Announcement",
    emptyData: "Announcement data",
    allStatus: "All Status",
    statusDraft: "Draft",
    statusSent: "Sent",
    announcementId: "Announcement ID",
    nameActivity: "Activity Name",
    targetUser: "Target User",
    releaseDate: "Release Date",
    status: "Status",
    createdAt: "Created Date",
    description: "Description",
    attachment: "Attachment",
    banner: "Banner",
    target: "Target",
    pinnedMessage: "Pin Message",
    pinnedYes: "Message Pinned",
    lastModified: "Last Modified",
    edit: "Edit",
    optional: "(Optional)",
    placeholderName: "Enter activity name",
    placeholderDescription: "Write news description here",
    changeFile: "Change File",
    targetHint: "Target will receive notifications on their Genesis account",
    pinnedHint:
      "Pinned messages will appear at the top of the notification page. Use this to highlight important messages.",
    save: "Save",
    successTitle: "Changes Saved Successfully!",
    successMessage: 'News "{name}" has been updated successfully',
    ok: "OK",
    confirmLeaveTitle: "Are you sure you want to leave?",
    confirmLeaveMessage:
      "Please confirm, you will lose all data if you leave this page.",
    leave: "Leave",
    back: "Back",
    confirmSaveTitle: "Confirm Changes",
    confirmSaveMessage: 'Are you sure you want to save changes to "{name}"',
    confirmDeleteTitle: "Are you sure you want to delete this activity?",
    confirmDeleteMessage:
      "Please confirm, you will lose this activity data when you delete it",
    delete: "Delete",
    invalidEndDate: "End date must not be less than or equal to current date",
    maxSizeFormatBanner:
      "Max size: 5MB, Format: jpg, png. Recommended ratio 2:4 (e.g. 200px X 800px)",
    loading: "Loading...",
    invalidFileMessage:
      "Please ensure file format and size are correct (max 16MB)",
    targetWillReceive:
      "Target will receive notifications on their Genesis account",
    selectTargetHint: "Select target that will receive notifications.",
    pinnedActive: "Message pinned",
    pinnedInactive: "Message not pinned",
    invalidReleaseDate:
      "Release date must not be less than or at least one hour from now",
    captionBanner:
      "Max size: 5MB, Format: jpg, png. Recommended ratio 2:4 (e.g. 200px X 800px)"
  },
  receipt: {
    createdAt: "created",
    createdAtV2: "created at",
    estimation: "estimate",
    ref: "Ref",
    shipper: "shipper",
    receiver: "receiver",
    destination: "destination",
    home: "home",
    office: "office",
    goodsValue: "good value",
    totalCost: "total cost",
    shippingCost: "shipment",
    shippingCostV2: "Shipment",
    insurance: "insurance",
    totalWeight: "total weight",
    chargeableWeight: "chargeable\nweight",
    taxBm: "Tax/BM",
    others: "other",
    othersV2: "Other",
    downloadApps:
      "Download Lion Parcel App via Appstore or Playstore and track your package now!",
    toc: "T&C : lionparcel.com/sk",
    goodValue: "good value",
    currencyDisplayGoodValue: "{value} USD",
    goodsPrice: "goods price",
    returnFee: "return fee",
    returnFeeV2: "Return",
    returnCost: "return cost",
    codFee: "COD Fee",
    dfodFee: "DFOD Fee",
    returStatement: "*if return",
    senderPage: "Scissors for shipper",
    terms: "Terms and Conditions Apply.",
    info: "For more information: https://lionparcel.com/sk",
    infoTracking: "to track your\npackage in real\ntime!",
    infoTrackingPrn: {
      info1: "Want to know the",
      info2: "status of your package? ",
      info3: "Track it in real-time!",
      info4: ""
    },
    scanHere: "scan here",
    trackPackageHere: "Track your\npackage here",
    productTable: {
      no: "No.",
      name: "Product Name",
      variant: "Variant",
      qty: "Qty"
    },
    customSla: "*Excludes customs SLA"
  },
  invoice: {
    date: "date",
    shipperName: "shipper name",
    shipperPhone: "shipper phone",
    shipperAddress: "shipper address",
    conssigneeID: "ID consignee",
    postCode: "post code",
    conssigneeName: "consignee name",
    conssigneePhone: "consignee phone",
    conssigneeEmail: "consignee email",
    conssigneeAddress: "consignee address",
    dutyTaxTerms: "Duty & Tax Terms",
    signatureOfShipper: "Signature of Shipper",
    itemDescription: "Item Description/ Komoditi",
    unitValue: "Unit Value/Harga Barang",
    qty: "Quantity/Jumlah",
    totalValue: "Total Value/Total Harga Barang",
    weight: "Weight/Berat",
    note:
      "*Note : Publish rate not include tax fee (Ongkos kirim tidak termasuk biaya pajak)",
    term:
      "I declare all the information contained in this invoice to be true and correct, and i am willing to bear\nany cost if the information is incorrect. (Saya menyatakan semua informasi yang berada di invoice\nini adalah benar dan saya bersedia menanggung biaya jika informasi yang saya berikan salah)",
    commodity: "commodity",
    HSCODE: "HSCODE",
    unitValueGoods: "unit value goods",
    totalItem: "total item",
    totalValueGoods: "total value goods",
    totalWeight: "total weight"
  },
  onProcessStt: {
    pageTitle: "On Process STT",
    editBooking: "Edit Booking",
    filter: {
      searchPlaceholder: "Search for STT number"
    },
    table: {
      sttNumber: "STT number",
      shipmentNumber: "Shipment ID",
      destination: "Destination Address",
      status: "Latest Status",
      adjustmentStatus: "Adjustment Status",
      serviceType: "Service Type",
      bookingDate: "Booking Date",
      lastUpdate: "Last Updated",
      bookingFor: "Booking For",
      destinationCity: "Destination city",
      action: "Action"
    },
    emptyData: "On Process STT data",
    deleteTooltip: "Cancel Booking",
    action: {
      editBooking: "Edit Booking",
      printThermal: "Print Thermal Resi",
      printThermalPdf: "Print Thermal Resi PDF",
      printBasicPdf: "Print Basic/Save to PDF",
      printCommercialInvoice: "Print Commercial Invoice"
    },
    tooltip: {
      dexAttempt: "DEX attempt"
    }
  },
  booking: {
    titleConfirmReject: "Cancellation Confirmation?",
    messageConfirmReject:
      "Select cancellation reason. Canceled STT numbers are non-refundable",
    submitConfirmReject: "Yes, Cancel",
    cancelConfirmReject: "No",
    placeholderReason: "Select cancellation reason",
    titleSuccessReject: "Cancellation Success!",
    messageSuccessReject:
      'Order with STT number "{sttNumber}" canceled successfully. Check detailed status for cancellation reason',
    messageInputNewStt:
      "Cancellation of a booking for the reasons mentioned above must include the latest STT number.",
    errorInputNewStt: "STT number is invalid, check & change again.",
    errorInputNewSttSame: "STT number cannot be the same as the one in Cancel",
    generateNewSttForReturn: "Create new STT for package return",
    printReceipt: "Print Receipt",
    printThermalResiSuccess: "Print Thermal Resi",
    printBasicPdfSuccess: "Print Basic/Save to PDF",
    successOk: "OK",
    errorNotAllowEditBeforeCs:
      "Your account cannot make changes. Please contact ",
    errorNotAllowEditAfterCs: " for change requests."
  },
  customProcess: {
    selectStatus: "Select status",
    allStatus: "All status",
    updateStatus: "Update Status",
    emptyData: "Custom Process",
    reasonPlaceholder: "Select reason",
    titleModalReroute: "Confirm status update to REROUTE?",
    titleModalMisbooking: "Confirm status update to MISBOOKING?",
    msgModalRerouteMisbooking:
      "Make sure all STT details are correct, because there will be a deduction from the POS balance.",
    titleModalRejected: "Confirm status update to REJECTED?",
    msgModalRejected: "Make sure all STT details are correct.",
    titleModalDefault: "Confirm update status?",
    msgModalDefault: "Make sure all STT details are correct.",
    no: "No.",
    totalStt: "Total STT",
    remarks: "Remarks",
    action: "Action",
    print: "Print",
    forStatusOnlyOneStt: "For status ",
    statusRts: "RTS",
    statusRtshq: "RTSHQ",
    and: "and",
    onlyOneSttSuffix: ", only 1 STT number can be updated",
    mustChangeAddressMisbooking:
      "Receiver address must be updated to process MISBOOKING.",
    addressChangedByBackline:
      "This receiver address has been updated by backline, you can proceed with misbooking update from console account",
    hubDestination: "Destination hub",
    vehicleNumber: "Vehicle number",
    selectPos: "Select POS",
    changeAddress: "Change Address",
    changeReceiverAddress: "Change Receiver Address",
    scanSttFailed: "Scan STT Number Failed",
    addSttFailed: "Add STT Number Failed",
    statusChangeSuccess: "Status Update Successful",
    printReceipt: "Print Receipt",
    printThermalReceipt: "Print Thermal Receipt",
    printBasicPdf: "Print Basic/Save to PDF",
    selectConsoleType: "Select console type",
    consolidator: "Consolidator",
    subConsolidator: "Sub Consolidator",
    selectRemarks: "Select Remarks",
    remarkAddressChangeCustomer: "Address change request from Customer",
    remarkAddressChangePos: "Address change request from POS"
  },
  customProcessManifest: {
    detailTitle: "Detail Custom Process",
    customStatus: "Custom Status",
    totalSTT: "Total STT",
    totalKoli: "Total Koli",
    totalGrossWeight: "Total Gross Weight",
    totalChargeableWeight: "Total Chargeable Weight",
    createdAt: "Created Date",
    printReceiptCustomProcess: "Print Custom Process Receipts",
    printPdf: "Print PDF",
    consolidatorCity: "Consolidator city",
    createdBy: "Created by",
    createdDateAndTime: "Created date and time",
    status: "Status",
    totalSTTPieces: "Total STT/pieces",
    totalDimensionWeight: "Total dimension weight",
    noSTT: "STT number",
    noSTTReplacement: "No. STT replacement",
    originCity: "Origin city",
    destinationCity: "Destination city",
    origin: "Origin",
    destination: "Destination",
    grossWeight: "Gross weight",
    dimensionweight: "Dimension weight",
    chargeableWeight: "Chargeable Weight",
    vehicleNumber: "Vehicle number"
  },
  hubToHub: {
    menuTitle: "Hub to Hub",
    inHub: "In Hub",
    outHub: "Out Hub",
    updateInHub: "Update In Hub",
    updateOutHub: "Update Out Hub",
    searchManifestPlaceholder: "Search manifest number",
    last30Days: "Last 30 days",
    no: "No",
    noManifest: "No. Manifest",
    totalStt: "Total STT",
    totalKoli: "Total koli",
    totalGrossWeight: "Total gross weight",
    manifestDate: "Manifest date",
    plateNumber: "Plate number",
    hubDestination: "Destination hub",
    actions: "Actions",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    hubLocation: "Hub location",
    consolidatorLocation: "Consolidator location",
    totalSttKoli: "Total STT/pcs",
    totalWeight: "Total weight",
    createdBy: "Created by",
    scanEmptyCta: "Start entering/scanning STT number now.",
    searchBagSttPlaceholder: "Search Bag/STT number",
    totalSttKoliLabel: "Total STT/pcs",
    grossWeight: "Gross weight",
    processManifest: "Process manifest",
    bagSttNotFound: "Bag/STT number not found.",
    noPackagesScanned: "No packages scanned yet.",
    partiallyUpdated: "Some STTs were updated successfully.",
    confirmProcessManifest: "Confirm Process Manifest",
    plateNumberPlaceholder: "Enter plate number",
    destinationHub: "Destination hub",
    back: "Back",
    process: "Process",
    manifestInhub: "Manifest INHUB",
    manifestOuthub: "Manifest OUTHUB",
    inhubManifestTitle: "Inhub Manifest",
    outhubManifestTitle: "Outhub Manifest",
    noBagDem: "No. Bag/DEM",
    noStt: "No. STT",
    refNo: "Ref. No.",
    koli: "Pcs",
    weight: "Weight",
    product: "Product"
  },
  dexAssessment: {
    menuTitle: "DEX Assessment",
    listTicketTitle: "DEX Ticket List",
    detailTitle: "DEX Ticket List | Detail",
    downloadData: "Download Data",
    searchPlaceholder: "Search Ticket / STT No.",
    timeRangeDefault: "Today",
    filterReasonDex: "DEX Reason",
    placeholderReasonDex: "Select DEX Reason",
    statusDexAsesmen: "DEX Assessment Status",
    placeholderStatusDex: "Select DEX Status",
    statusDisputeConsolidator: "Consolidator Dispute Status",
    placeholderStatusDispute: "Select Dispute Status",
    searchCsName: "Search CS Name",
    placeholderCsName: "Type or select CS name",
    consolidator: "Consolidator",
    placeholderConsolidator: "Type or select 3LC",
    totalReasonFormat: "{count} DEX Reason(s)",
    statusValid: "Valid",
    statusInvalid: "Invalid",
    statusNoStatus: "No Status Yet",
    statusDisputeRequested: "Requested",
    statusDisputeRejected: "Rejected",
    statusDisputeApproved: "Approved",
    columnTicketId: "Ticket ID",
    columnNoStt: "STT No.",
    columnTanggalDex: "DEX Date",
    columnAlasanDex: "DEX Reason",
    columnStatusDexAsesmen: "DEX Assessment Status",
    columnStatusDitentukanOleh: "Status Determined By",
    columnStatusSanggah: "Dispute Status",
    columnNamaCsL1: "CS L1 Name",
    columnTanggalDitugaskanCsL1: "CS L1 Assigned Date",
    columnTanggalDiselesaikanCsL1: "CS L1 Completed Date",
    columnNamaCsL2: "CS L2 Name",
    columnTanggalDitugaskanCsL2: "CS L2 Assigned Date",
    columnTanggalDiselesaikanCsL2: "CS L2 Completed Date",
    columnNamaKonsolidator: "Consolidator Name",
    columnTanggalDitugaskanKonsolidator: "Consolidator Assigned Date",
    columnTanggalDiselesaikanKonsolidator: "Consolidator Completed Date",
    columnNamaCsL2Sanggah: "CS L2 Dispute Name",
    columnTanggalDitugaskanCsL2Sanggah: "CS L2 Dispute Assigned Date",
    columnTanggalDiselesaikanCsL2Sanggah: "CS L2 Dispute Completed Date",
    emptyHeaderMessage: "No DEX Ticket List",
    emptyMessage: "Start creating DEX Ticket List and check it here",
    infoSanggahanKonsol: "Consolidator Dispute Information",
    fotoSanggahanKonsol: "Consolidator Dispute Photo",
    catatanDariKonsol: "Note From Consolidator",
    fotoDex: "DEX Photo",
    lampirkanFotoSanggahan: "Attach Dispute Photo",
    lampirkanFoto: "Attach Photo",
    komentarSanggahan: "Dispute Comment",
    placeholderSanggahan: "Enter Your Dispute Here",
    buttonSanggah: "Dispute",
    buttonTerima: "Accept",
    disputeBefore: "Dispute before {timeLeft}",
    timeOverDispute: "Your time to dispute has ended",
    submitFailed: "Submit DEX Assessment Failed!",
    statusSanggah: "Dispute Status",
    statusFinalAsesment: "Final Assessment Status",
    lihatDetail: "View Detail",
    summaryTicketInvalid: "Invalid Tickets",
    summaryDisputeRequested: "Dispute Requested",
    summaryDisputeApproved: "Dispute Approved",
    summaryDisputeRejected: "Dispute Rejected",
    summaryAcceptDex: "Accept DEX",
    summaryTotalTicket: "Total Tickets",
    summaryTicketQuota: "Ticket/Quota",
    summaryTicketFinished: "Tickets Completed",
    summaryTicketValid: "Valid Tickets",
    summaryTicketL1Finished: "L1 Tickets Completed",
    summaryTicketDisputeFinished: "Dispute Tickets Completed"
  },
  dexAssessmentConsolidator: {
    pageTitle: "DEX Assessment Dashboard",
    summaryDex: "DEX Summary",
    downloadData: "Download Data",
    downloadFailed: "Download Failed!",
    sectionSttDex: "STT DEX",
    sectionDexDispute: "DEX Dispute",
    sectionTotalDexByReason: "Total DEX by reason",
    placeholderStatusDex: "Select DEX status",
    sectionTotalDexByTimeRange: "Total DEX by time range",
    sectionTotalCourierInvalidDex: "Total invalid DEX courier",
    placeholderStatus: "Select status",
    sectionPercentageDexAttempt: "DEX attempt percentage",
    sectionDexFromSourceDex: "DEX from DEX source percentage",
    sectionPercentageRtsDex: "DEX percentage requiring RTS",
    sectionTotalDexPerDay: "Total DEX per day",
    sectionCourierDex: "Courier DEX",
    sortOrder: "Sort",
    searchCourierName: "Search courier name",
    emptyNoCourierDex: "No Courier DEX",
    emptyMessageCourierDex:
      "Start creating Courier DEX and check the list here",
    emptyNoReasonDex: "No DEX Reason",
    emptyMessageReasonDex: "Start creating DEX Reason and check the list here",
    columnNo: "No",
    columnCourierName: "Courier Name",
    columnTotalDel: "Total DEL",
    columnTotalDex: "Total DEX",
    columnPercentageDex: "DEX Percentage",
    columnTotalDexMismatch: "Total DEX mismatch",
    columnPercentageDexMismatch: "DEX mismatch percentage",
    columnTotalDexMatch: "Total DEX match",
    columnPercentageDexMatch: "DEX match percentage",
    columnReasonDex: "DEX Reason",
    sortTotalDexHighest: "Total DEX highest",
    sortTotalDexLowest: "Total DEX lowest",
    sortTotalInvalidHighest: "Total invalid DEX highest",
    sortTotalInvalidLowest: "Total invalid DEX lowest",
    sortTotalRejectedHighest: "Total DEX invalid dispute rejected highest",
    sortTotalRejectedLowest: "Total DEX invalid dispute rejected lowest",
    sortCourierRejectedHighest: "Total dispute rejected highest",
    sortCourierRejectedLowest: "Total dispute rejected lowest",
    sortPercentageDexHighest: "DEX percentage highest",
    sortPercentageDexLowest: "DEX percentage lowest",
    sortPercentageInvalidHighest: "Invalid DEX percentage highest",
    sortPercentageInvalidLowest: "Invalid DEX percentage lowest",
    statusAll: "All Status",
    statusDexValid: "DEX Valid",
    statusDexInvalid: "DEX Invalid",
    statusDexRequested: "DEX Invalid disputed",
    statusDexApproved: "DEX Invalid dispute approved",
    statusDexRejected: "DEX Invalid dispute rejected",
    statusDexAccepted: "DEX Invalid accepted",
    suffixDex: "DEX",
    suffixCourier: "courier",
    ticketCount: "ticket(s)",
    sourceDriverApp: "Driver Apps",
    sourceGenesis: "Genesis",
    attemptOne: "1 Time",
    attemptTwo: "2 Times",
    attemptThreePlus: ">= 3 Times"
  },
  dexAssessmentDashboard: {
    breakdownTicketDex: "DEX Ticket Breakdown",
    breakdownTicketDexSanggahL2: "DEX Ticket Dispute L2 Breakdown",
    top20KonsolTiketDex: "Top 20 Consolidator DEX Tickets",
    top10KonsolTiketDexSanggahL2: "Top 10 Consolidator DEX Dispute L2 Tickets",
    listAgentCsL1: "CS L1 Agent List",
    listAgentCsL2: "CS L2 Agent List",
    sortOrder: "Sort",
    searchCsName: "Search CS name",
    emptyListAgentCsL1: "No CS L1 Agent List",
    emptyListAgentCsL2: "No CS L2 Agent List",
    columnNo: "No",
    columnNamaCs: "CS Name",
    columnStatus: "Status",
    columnKuotaTiket: "Ticket Quota",
    columnTiketDiassign: "Tickets Assigned",
    columnTiketSelesai: "Tickets Completed",
    columnPersentaseTiketSelesai: "Completion Percentage",
    columnRataRataWaktuSelesai: "Average Completion Time",
    columnTotalJamAktif: "Total Active Hours",
    statusActive: "Active",
    statusInactive: "Inactive",
    sortPercentageDoneHighest: "Highest completion percentage",
    sortPercentageDoneLowest: "Lowest completion percentage",
    totalTicketDexPerHari: "Total DEX Tickets Per Day",
    totalTicketDexSanggahL2PerHari: "Total DEX Dispute L2 Tickets Per Day",
    totalPercobaanTicketDex: "Total DEX Attempt Tickets",
    courierLabel: "Courier:",
    totalTicketDexLabel: "Total DEX Tickets:",
    emptyTop10Konsol: "No Top 10 Consolidators",
    emptyTop10KonsolMessage:
      "Start creating Top 10 Consolidators and check the list here",
    emptyKurir: "No Couriers",
    emptyKurirMessage: "Start creating Couriers and check the list here",
    totalCustomerService: "Total Customer Service",
    totalCsL1: "Total Customer Service L1",
    totalCsL2: "Total Customer Service L2",
    penyelesaianTercepat: "Fastest completion",
    penyelesaianTerlama: "Slowest completion",
    persentaseSelesaiTerbanyak: "Highest completion percentage",
    persentaseSelesaiTersedikit: "Lowest completion percentage",
    ringkasanDexIndikasiPalsu: "Fake DEX Indication Summary",
    totalTicketDexIndikasiPalsu: "Total Fake DEX Indication Tickets",
    ticketDexDariAlasanDex: "DEX Tickets by DEX Reason",
    totalTicketDexBerdasarkanRentangWaktu: "Total DEX Tickets by Time Range",
    backlogTicketDexAgenCsL1: "DEX Ticket Backlog for CS L1 Agents",
    backlogTicketDexAgenCsL2: "DEX Ticket Backlog for CS L2 Agents",
    titleChartByReason: "DEX Tickets by Reason",
    titleChartByReasonDispute: "DEX Dispute L2 Tickets by Reason"
  },
  deliveryManifest: {
    title: "Delivery Manifest",
    menuName: "Delivery Manifest",
    createButton: "Create Manifest",
    searchPlaceholder: "Search Manifest No./STT No.",
    timeRangeDefault: "Last 7 days",
    emptyState: "Delivery Manifest",
    columns: {
      no: "No.",
      noDeliveryManifest: "No. Delivery Manifest",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total dimension weight",
      createdAt: "Created at",
      action: "Action"
    },
    actions: {
      printManifest: "Print Manifest",
      printLabel: "Print Label"
    },
    update: {
      title: "Create Manifest",
      partnerName: "Partner name",
      userType: "User type",
      destinationCity: "Destination city",
      createdAt: "Created at",
      datePlaceholder: "Select or enter vehicle plate number",
      noStt: "No. STT",
      noSttLabel: "Example: 99LP1234567890123/88-22-12345678",
      noSttPlaceholder: "Enter STT No. or Scan Barcode/QR Code",
      weightExcessError:
        "Weight excess occurred; status cannot be updated to Delivery Manifest",
      maxStt: "Max. {max} STT",
      add: "Add",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total dimension weight",
      delete: "Delete",
      process: "Process",
      createManifest: "Create Manifest",
      createAndPrintPdf: "Create & Print PDF",
      no: "No.",
      noRef: "No. Reference",
      product: "Product",
      commodity: "Commodity",
      totalPieces: "Total pieces",
      grossWeight: "Gross weight",
      volumeWeight: "Dimension weight",
      chargeableWeight: "Chargeable weight",
      deliveryTo: "Delivery to",
      codFee: "COD fee",
      needRelabel: "Need relabel",
      successTitle: "Creation successful",
      successMessage: "Delivery Manifest has been created successfully.",
      packageTakenByRecipient: "Package will be taken by recipient",
      scanFailed: "Scan STT failed",
      addFailed: "Add STT failed",
      noSttSuccess: "STT succeeded",
      noSttFailed: "STT failed",
      ok: "OK",
      download: "Download",
      okUnderstand: "OK, got it",
      sttNotFoundOrRemoved: "STT number not found or already removed",
      sttAlreadyInput: "STT already added",
      sttNotFound: "STT number not found",
      leaveTitle: "Leave this page?",
      leaveMessage: "Your data will be lost if you leave this page.",
      confirmLeave: "Leave",
      cancelLeave: "Back",
      confirmationTitle: "Confirm creation",
      confirmationMessage: "Please ensure all STT details are correct.",
      confirmationProcess: "Process",
      confirmationBack: "Back",
      deleteItemTitle: "Remove item",
      deleteItemMessage:
        "Enter STT number or scan barcode/QR to remove item from list.",
      deleteItemError: "STT number not found or already removed",
      removed: "Removed",
      deleteItem: "Delete",
      cancel: "Cancel"
    },
    notification: {
      inputSuccess: "STT number added successfully",
      noStt: "No. STT",
      destinationCity: "Destination city",
      product: "Product",
      commodity: "Commodity",
      totalKoli: "Total pieces",
      codFee: "COD fee"
    }
  },
  updateDelivery: {
    title: "Update DEL",
    menuName: "Delivery",
    emptyState: "Delivery",
    createButton: "Update DEL",
    printButton: "Print",
    timeRangeOptions: "custom, today, last 7 days, last 14 days",
    columns: {
      no: "No.",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      driverName: "Courier name",
      driverPhone: "Courier phone no.",
      deliveredBy: "Delivered by",
      createdAt: "Created at",
      action: "Action"
    },
    form: {
      email: "Email",
      title: "Update DEL",
      partnerName: "Partner name",
      userType: "User type",
      originCity: "Origin city",
      dateCreated: "Created at",
      datePlaceholder: "Select or enter vehicle plate number",
      deliveredBy: "Delivered by",
      driverUsesApp: "Does the courier use the Driver app?",
      driverName: "Courier name",
      selectDriver: "Select courier",
      selectClientPartner: "Type or select client/partner",
      deliveryNote:
        "Delivery data from this courier will not be recorded in reconciliation.",
      noStt: "No. STT",
      noSttLabel: "Example: 99LP1234567890123/88-22-12345678",
      noSttPlaceholder: "Enter STT No. or Scan Barcode/QR Code",
      weightExcessError:
        "Weight excess occurred; status cannot be updated to DEL",
      failedGetDriver: "Failed to get courier data",
      add: "Add",
      confirmationTitle: "Confirm update",
      confirmationMessage: "Please ensure all STT details are correct.",
      textCancel: "Back",
      textSuccess: "Process",
      successTitle: "Update successful",
      successMessage: "STT status has been successfully updated to DEL.",
      partialMessage:
        "Some STT statuses have been updated to DEL,<br />but some failed.<br />Please download to view errors.",
      failedTitle: "Update failed",
      failedMessage: "DEL status failed to update.",
      download: "Download",
      ok: "OK",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total dimension weight",
      delete: "Delete",
      process: "Process",
      updateDel: "Update DEL",
      updateAndPrintPdf: "Update & Print PDF",
      no: "No.",
      noSttCol: "No. STT",
      needRelabel: "Need relabel",
      urgentRts: "Urgent RTS",
      noRef: "No. Reference",
      deliveryTo: "Delivery to",
      codFee: "COD fee",
      dest: "Dest.",
      product: "Product",
      commodity: "Commodity",
      koli: "Pieces",
      grossWeight: "Gross weight",
      volumeWeight: "Dimension weight",
      chargeableWeight: "Chargeable weight"
    },
    deleteStt: {
      title: "Remove item",
      message:
        "Enter STT number or scan barcode/QR<br />to remove item from DEL list.",
      removed: "Removed",
      cancel: "Cancel",
      delete: "Delete",
      errorNotFound: "STT number not found or already removed"
    },
    pdf: {
      title: "Delivery Manifest",
      consolidatorCity: "Consolidator city",
      createdBy: "Created by",
      totalWeight: "Total weight",
      totalSttKoli: "Total STT/pieces",
      manifestDate: "Manifest date",
      courier: "Courier",
      no: "No.",
      sttNo: "STT number",
      refNo: "Reference number",
      productType: "Shipment type",
      service: "Service",
      pieceWeight: "Pieces/weight",
      demNo: "DEM number",
      ursaCode: "Ursa code",
      courierSignature: "Courier",
      supervisorSignature: "Operations Supervisor"
    }
  },
  podDex: {
    menuTitle: "POD/DEX",
    menuName: "POD/DEX",
    tabDelDex: "DEL/DEX",
    tabCodrej: "CODREJ",
    tabPod: "POD",
    searchPlaceholder: "Search STT No.",
    timeRangeDefault: "today",
    emptyStateHeader: "No POD/DEX data yet",
    emptyStateMessage:
      "All POD/DEX data (DEL/DEX, CODREJ, POD) will be listed here.",
    updateButton: "Update POD/DEX",
    downloadButton: "Download Data",
    columns: {
      no: "No.",
      noStt: "No. STT",
      noReferensi: "No. Reference",
      totalKoli: "Total pieces",
      beratDikenakanBiaya: "Chargeable weight",
      produk: "Product",
      statusTerakhir: "Latest status",
      komoditas: "Commodity",
      biayaCod: "COD fee",
      tipePembayaranCod: "COD payment type",
      tanggalDel: "DEL date",
      namaKurir: "Courier name",
      noTelpKurir: "Courier phone no.",
      dikirimOleh: "Delivered by",
      pengirimanKe: "Delivery to",
      action: "Action"
    },
    statusLatest: "Latest Status",
    statusDel: "DEL",
    statusDex: "DEX",
    updateModalTitle: "Update POD/DEX",
    update: {
      noStt: "No. STT",
      totalKoli: "Total pieces",
      beratDikenakanBiaya: "Chargeable weight",
      biayaCod: "COD fee",
      produk: "Product",
      komoditas: "Commodity",
      namaPenerima: "Recipient name",
      alamatPenerima: "Recipient address",
      noTelpPenerima: "Recipient phone no.",
      infoKurir: "Courier info",
      terkirim: "Delivered",
      pilih: "Select",
      ya: "Yes",
      tidak: "No",
      placeholderNamaPenerima: "Enter recipient name",
      konfirmasiPerubahan: "Confirm change",
      confirmMessagePod:
        "Enter recipient name and attach delivery proof to update status to POD.",
      confirmMessageDex:
        "Select reason for undelivered parcel and attach proof for status change to DEX.",
      pilihRelasi: "Select relation",
      alasanTidakTerkirim: "Reason not delivered",
      alasanKendala: "Reason / constraint",
      placeholderAlasan: "Briefly describe the constraint...",
      buktiPengiriman: "Delivery proof",
      kembali: "Back",
      update: "Update",
      successTitle: "Status updated successfully",
      successMessagePod:
        "STT status has been updated to POD. Recipient name will appear in shipment status detail.",
      successMessageDex:
        "STT status has been updated to DEX. Undelivered reason will appear in shipment status detail.",
      inginPodDex: "POD/DEX this parcel?",
      sttRtsHal: "This STT is already marked as RTS/HAL",
      pilihAlasan: "Select reason",
      ok: "OK"
    },
    advanceFilter: {
      filter: "Filter",
      reset: "Reset",
      tipeStt: "STT type",
      placeholderTipeStt: "Select STT type",
      tipePembayaranCod: "COD payment type",
      placeholderTipePembayaranCod: "Select COD payment type",
      semua: "All",
      cod: "COD",
      nonCod: "Non COD",
      cash: "Cash",
      qris: "QRIS",
      gratis: "FREE"
    },
    download: {
      modalTitle: "Download Report",
      tanggal: "Date",
      timeRangeDefault: "today",
      searchButton: "Search",
      errorMessage: "Download failed"
    },
    unpaidModal: {
      title: "Ensure STT is paid",
      message:
        "Check that adjusted or overweight STT numbers have been fully paid.",
      ok: "OK"
    },
    proofButton: "Proof"
  },
  cnManifest: {
    pageTitle: "CN Manifest",
    filterTypeSttListing: "STT Listing Type",
    filterTypeUser: "User Type",
    filterPartner: "Client/Partner/Customer Name",
    filterDestinationCity: "Destination City",
    placeholderDestinationCity: "Input & select destination city",
    placeholderSttNo: "Input or Choose STT Number",
    placeholderClientPartner: "Type or select client/partner name",
    filterDateStart: "Starting From",
    filterDateEnd: "Until",
    errorInvalidStartDate: "Start date cannot be later than the end date",
    errorInvalidDuration: "Selected period must not exceed 14 days",
    errorInvalidEndDate: "End date cannot be less than the start date",
    emptyListMessage: "Oops.. No data to show yet",
    buttonSearch: "Search",
    buttonExportCsv: "Export to CSV",
    exportError: "Download Failed",
    columnNo: "No.",
    columnBookingDate: "Booking Date",
    columnNoStt: "No. STT",
    columnDestinationCity: "Destination City",
    columnTotalPiece: "Total Pieces",
    columnTotalWeight: "Total Weight",
    columnTotalVolume: "Total Volume",
    columnProduct: "Product",
    columnRecipient: "Recipient",
    columnRecipientAddress: "Recipient Address",
    columnRecipientPhone: "Recipient Phone No.",
    columnCommodityType: "Commodity Type",
    columnHsCode: "HS Code",
    columnNpwp: "NPWP",
    columnItemPrice: "Item Price",
    columnBm: "BM",
    columnPpn: "PPN",
    columnPph: "PPH",
    columnTotalGoodTax: "Total Good Tax",
    columnTaxImposition: "Tax Imposition",
    columnStatus: "Status",
    columnBookedBy: "Booked By",
    columnTotalAmount: "Total Amount",
    sttListingTypeBookingDate: "Booking Date",
    sttListingTypeSttList: "No. STT / No. Ref",
    filterDestinationCityAll: "All",
    tagPlaceholderStt: "Press enter to add No. STT",
    userTypeConsole: "Consolidator",
    userTypeSubconsole: "Subconsolidator",
    userTypePos: "POS",
    userTypeClient: "Client",
    userTypeCustomer: "Customer"
  },
  userManagement: {
    list: {
      title: "User Management",
      searchPlaceholder: "Search username or user ID",
      createUser: "Create User",
      emptyData: "user data",
      filter: {
        filter: "Filter",
        reset: "Reset",
        accountType: "Account Type",
        reference: "Reference",
        hub: "Hub",
        division: "Division",
        status: "Status",
        selectAccountType: "Select account type",
        selectReference: "Select reference",
        selectHub: "Select hub",
        selectDivision: "Select division",
        selectStatus: "Select status"
      },
      column: {
        userId: "User ID",
        username: "Username",
        email: "Email",
        phoneNumber: "Phone Number",
        accountType: "Account Type",
        division: "Division",
        reference: "Reference",
        role: "Role",
        hub: "Hub",
        shuttle: "Shuttle",
        accountStatus: "Account Status"
      }
    },
    detail: {
      userId: "User ID",
      username: "Username",
      accountType: "Account Type",
      division: "Division",
      role: "Role",
      assignedTo3lc: "Assigned to 3LC",
      all3lc: "All",
      phoneNumber: "Phone Number",
      email: "Email",
      reference: "Reference",
      shuttle: "Shuttle",
      hub: "Hub",
      hubCode: "Hub Code",
      hubName: "Hub Name",
      createdAt: "Created Date",
      updatedAt: "Last Updated",
      accountStatus: "Account Status",
      edit: "Edit",
      resetPassword: "Reset Password",
      noHub: "No hub"
    },
    edit: {
      title: "Edit User",
      save: "Save",
      username: "Username",
      email: "Email",
      phoneNumber: "Phone Number",
      accountType: "Account Type",
      role: "Role",
      reference: "Reference",
      accountStatus: "Account Status",
      accountStatusDescription:
        "Accounts with active status can be used for login. You can activate or deactivate the account at any time.",
      accountActive: "Active",
      accountInactive: "Inactive",
      statusUser: "User Status",
      createdAt: "Created Date",
      lastUpdated: "Last Updated",
      modalDeactivateTitle: "Deactivate Account",
      modalDeactivateMessage:
        "While the user is inactive, the account cannot be used for login",
      modalActivateTitle: "Activate Account",
      modalActivateMessage:
        "While the user is active, the account can be used for login",
      modalDeactivate: "Deactivate",
      modalActivate: "Activate",
      back: "Back",
      modalSuccessTitle: "Changes Saved",
      modalConfirmTitle: "Confirm Account Changes",
      modalConfirmMessage:
        "Are you sure you want to save account changes for {name}?",
      modalLeaveTitle: "Are you sure you want to leave?",
      modalLeaveMessage:
        "Please confirm. You will lose all data if you leave this page.",
      leave: "Leave",
      ok: "OK",
      modalSuccessMessage: "User {name} has been updated successfully"
    },
    modalEditDetail: {
      oldEmail: "Old Email",
      newEmail: "New Email",
      placeholderNewEmail: "Enter new email",
      active: "Active",
      inactive: "Inactive",
      statusInfo:
        "Inactive accounts cannot perform any activities until reactivated. You can change status at any time.",
      selectRole: "Select Role",
      modal3lcTitle: "Selected 3LC Origin",
      cityOptionName: "city",
      all: "All",
      searchOrSelect3lc: "Search or select 3LC",
      selectHub: "Select hub",
      selectDivision: "Select division",
      selectShuttle: "Select shuttle",
      save: "Save",
      noShuttle: "No shuttle",
      titleStatus: "Change Account Status",
      titleEmail: "Change Email",
      titleRole: "Change Role",
      title3lc: "Change assigned 3LC",
      titleDefault: "Change",
      confirmStatusTitle: "Confirm {action}",
      activation: "Activation",
      deactivation: "Deactivation",
      statusInactiveMessage:
        "Inactive accounts cannot perform any activities until reactivated.",
      back: "Back",
      activate: "Activate",
      deactivate: "Deactivate",
      payloadTypeStatusAccount: "Account Status",
      statusSuccess: "{action} status updated successfully!",
      payloadTypeEmail: "Email",
      confirmChangeTitle: "Confirm Changes",
      confirmChangeMessage:
        "Are you sure you want to save account detail changes for username “{username}”?",
      confirmHubTitle: "Confirm hub data changes",
      confirmHubMessage: "Are you sure the changed hub data is correct?",
      yesSave: "Yes, save",
      confirmDivisionTitle: "Confirm division data changes",
      confirmDivisionMessage:
        "Are you sure the changed division data is correct?",
      confirmShuttleTitle: "Confirm shuttle data changes",
      confirmShuttleMessage:
        "Are you sure the changed shuttle data is correct?",
      hubUpdatedTitle: "Hub data updated successfully",
      ok: "OK",
      emailUpdatedSuccess: "Email updated successfully!",
      roleUpdatedSuccess: "Role updated successfully!",
      roleUpdateFailed: "Failed to update role!",
      assigned3lcConfirmTitle: "Change this 3LC assignment?",
      assigned3lcConfirmMessage:
        "Please make sure the user data you changed is correct.",
      assigned3lcUpdatedTitle: "Account 3LC updated successfully",
      assigned3lcUpdatedMessage:
        "Account “{accountId}” access for 3LC “{assigned3lc}” has been updated."
    },
    resetPassword: {
      modalTitle: "Confirm Change",
      modalMessage:
        'You have requested a password reset. The new password will be sent to <span class="text-blue-600 underline">{email}</span>.',
      cancel: "Back",
      submit: "Reset",
      successMessage:
        "Password reset successful. The new password has been sent to {email}",
      errorTitle: "Reset Password Failed"
    },
    add: {
      title: "Create New User",
      save: "Save",
      accountType: "Account Type",
      selectAccountType: "Select account type",
      division: "Division",
      selectDivision: "Select division",
      reference: "Reference",
      selectReference: "Select reference",
      role: "Role",
      selectRole: "Select role",
      hub: "Hub",
      selectHub: "Select hub",
      shuttleOptional: "Shuttle (optional)",
      selectShuttle: "Select shuttle",
      assignedTo3lc: "Assigned to 3LC",
      modal3lcTitle: "Selected 3LC Origin",
      all3lc: "All 3LC",
      searchOrSelect3lc: "Search or Select 3LC",
      username: "Username",
      placeholderUsername: "Enter user name",
      usernameFormatInvalid: "Username format is invalid",
      usernameRule1: "Username may only contain letters and full stops.",
      usernameRule2: "Username will be used for login with format:",
      email: "Email",
      placeholderEmail: "e.g email{'@'}gmail.com",
      phoneNumber: "Phone Number",
      placeholderPhone: "e.g 1123451234",
      emailInvalid: "The email you entered is invalid",
      emailDomainInvalid: "Email domain is not registered and valid",
      modalSuccessTitle: "Create New User Complete",
      all: "All",
      modalSuccessMessage:
        "User with name {name} has been created successfully",
      confirmLeaveTitle: "Are you sure you want to leave?",
      confirmLeaveMessage:
        "Please confirm. You will lose all data if you leave this page.",
      leave: "Leave",
      back: "Back",
      confirmCreateTitle: "Confirm User Creation",
      confirmCreateMessage:
        "Are you sure you want to save user with name {name}?",
      ok: "OK"
    }
  },
  posBranch: {
    pageTitle: "Branch POS & Pickup List",
    list: {
      searchPlaceholder: "Search POS name",
      createPos: "Create POS",
      emptyMessage: "No POS data to display",
      column: {
        no: "No.",
        posCode: "POS Code",
        posName: "POS Name",
        posType: "POS Type",
        districtCity: "District, City",
        lastTransaction: "Last transaction",
        balanceAvailable: "Available balance",
        partnerAreaName: "Partner area name",
        contractStatus: "Contract status",
        partnerStatus: "Partner status",
        action: "Action"
      },
      filter: {
        filter: "Filter",
        reset: "Reset",
        contractStatus: "Contract status",
        partnerStatus: "Partner status",
        posType: "POS type",
        selectStatus: "Select status",
        selectPosType: "Select type"
      },
      contractStatus: {
        active: "Active",
        waiting: "Waiting",
        nearlyExpired: "Nearly expired",
        expired: "Expired"
      },
      posType: {
        parent: "POS Parent",
        branch: "POS Child",
        pickup: "POS Pickup"
      },
      status: {
        freezed: "Freezed",
        notFreezed: "-",
        active: "Active",
        inactive: "Inactive"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze"
      }
    },
    detail: {
      pageTitle: "Branch POS & Pickup List | Detail",
      title: "Branch POS Detail",
      contractStatus: "Contract status",
      partnerStatus: "Partner status",
      balanceAvailable: "Available balance",
      tierLevel: "Tier level",
      createdAt: "Created date",
      updatedAt: "Last updated",
      qrCode: "QR code",
      tab: {
        parent: "Parent POS Detail",
        branchList: "Branch POS & Pickup List"
      },
      status: {
        freezed: "Freezed"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze",
        edit: "Edit",
        downloadQr: "Download QR Code"
      },
      contact: {
        title: "Contact Information",
        name: "Name",
        phone: "Phone number",
        jobTitle: "Job title",
        email: "Email"
      }
    }
  },
  urgentDeliveryManagement: {
    pageTitle: "Urgent Delivery Management",
    tabPod: "Urgent POD",
    tabRts: "Urgent RTS",
    tabHal: "Urgent HAL",
    tabTakenByRecipient: "Taken by Recipient",
    tabUrgentSearch: "Urgent Search",
    tabMonitorRelabel: "Monitor Relabel",
    searchPlaceholder: "Search STT no.",
    download: "Download",
    downloadData: "Download data",
    sortLatest: "Sort latest",
    pod: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnDeliveryType: "Delivery Service",
      columnReason: "Reason",
      columnUnprocessed: "Unprocessed",
      columnLastStatus: "Last Status",
      columnProductType: "Product Type",
      columnDexAttempt: "DEX Attempts (Customer)",
      columnRequestDate: "Request Date",
      columnBkdDate: "BKD Date",
      columnLastLocation: "Last Location",
      filterUrgent: "Urgent delivery",
      filterOverSla: "Over SLA limit",
      filterRedelivery: "Redelivery"
    },
    filter: {
      filter: "Filter",
      deliveryType: "Delivery type",
      selectDeliveryType: "Select delivery type",
      flaggingDate: "Flagging Date",
      reset: "Reset",
      apply: "Apply",
      caseType: "Case Type",
      selectCaseType: "Select case type",
      sttType: "STT Type",
      selectSttType: "Select STT type",
      timeRangeToday: "Today",
      timeRangeLast7: "Last 7 days",
      timeRangeLast30: "Last 30 days",
      customerRequest: "Customer Request",
      lastLocation: "Last location",
      lastLocationPlaceholder: "Select last location",
      selectedLastLocation: "{num} Location"
    },
    empty: {
      header: "No urgent deliveries yet",
      message: "Start entering/scanning STT numbers in the STI DEST menu.",
      filterNotFound: "No results found",
      filterNotFoundMessage: "Check and reset your filters."
    },
    rts: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnCaseType: "Case Type",
      columnReason: "Reason",
      columnSttType: "STT Type",
      columnOriginCity: "Origin City",
      columnLastStatus: "Last Status",
      columnProductType: "Product Type",
      columnDexAttempt: "DEX Attempts (Customer)",
      columnRequestDate: "Request Date",
      columnBkdDate: "BKD Date",
      columnLastLocation: "Last Location",
      requestDatePlaceholder: "Request Date",
      aggregator: "Aggregator",
      nonAggregator: "Non Aggregator"
    },
    hal: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnReason: "Reason",
      columnOriginCity: "Origin City",
      columnLastStatus: "Last Status",
      columnRequestTime: "Request Time",
      columnLastLocation: "Last Location",
    },
    detail: {
      requestType: "Request Type",
      lastStatus: "Last Status",
      reason: "Reason",
      requestDate: "Request Date",
      bkdDate: "BKD Date",
      destination: "Destination",
      supportingLink: "Supporting Data Link",
      notes: "Notes",
      proofPhoto: "Proof Photo"
    },
    error: {
      getDetailFailed: "Failed to get detail!",
      getPODSummaryFailed: "Failed to get POD summary!"
    },
    formatAgingDays: {
      days: "days",
      today: "Today"
    }
  },
  featureName: {
    Beranda: "Dashboard",
    "Lacak Pengiriman": "Track Shipment",
    "Daftar Booking": "Booking List",
    "Booking Bulk": "Bulk Booking",
    "Manual STT": "Manual STT",
    "Cetak Tagihan": "Print Invoice",
    "Cetak Resi": "Print Receipt",
    "CN Manifest": "CN Manifest",
    "Pesanan Kulioner": "Kulioner Orders",
    "STT Dalam Proses": "On Process STT",
    "Manajemen Kiriman Penting": "Urgent Delivery Management",
    "Kiriman Penting": "Urgent Delivery",
    "Request HAL": "Request HAL",
    "STT Kurang Bayar": "STT Paid/Unpaid",
    "Proses PUP": "PUP Process",
    "Proses STI SC": "STI SC Process",
    "Proses STO SC": "STO SC Process",
    "Proses STI": "STI Process",
    "Proses BAG": "BAG Process",
    "Proses RTC": "RTC Process",
    "Proses CARGO": "CARGO Process",
    "Proses STIDEST": "STIDEST Process",
    "Delivery Manifest": "Delivery Manifest",
    Delivery: "Delivery",
    "POD/DEX": "POD/DEX",
    "Transfer Hub (IN OUT HUB)": "Hub to Hub",
    "Proses DISPATCH": "Dispatch Process",
    "Handover Vendor (HND)": "Vendor Handover (HND)",
    "STT Shortland": "Shortland Cargo",
    "Proses Custom Status": "Custom Status Process",
    "Performa DEX Asesmen": "DEX Assessment Performance",
    "DEX Asesmen": "DEX Assessment",
    "Daftar DEX Asesmen": "DEX Assessment List",
    "Rekon Delivery": "Delivery Reconciliation",
    "Manajemen Pelanggan": "Customer Management",
    "POS Langganan": "POS Subscription",
    "Manajemen Kurir": "Courier Management",
    "Manajemen POS Cabang & Di-Pickup": "Branch POS & Pickup Management",
    "Manajemen Korporat": "Corporate Management",
    "Manajemen Partner": "Partner Management",
    "Manajemen User": "User Management",
    "Pusat Resolusi": "Resolution Center",
    "Base Rate": "Base Rate",
    "Konversi Mata Uang": "Currency Conversion",
    "Konfigurasi Harga": "Price Configuration",
    "Tarif Komoditas": "Commodity Tariff",
    "Pajak Barang": "Goods Tax",
    "Konfigurasi Komisi": "Commission Configuration",
    "Promo Diskon": "Promo Discount",
    "Konfigurasi COD": "COD Configuration",
    "Jenis Pengiriman": "Product",
    Komoditas: "Commodity",
    Embargo: "Embargo",
    "Area Cakupan": "Location Coverage",
    "Manajemen Leg": "Leg Management",
    "Manajemen Rute": "Route Management",
    "Manajemen Vendor": "Vendor Management",
    "Manajemen Moda": "Transport Management",
    "Bagging Grouping": "Bagging Grouping",
    "Konfigurasi Kargo": "Cargo Configuration",
    "Area Keterlambatan": "Delay Area",
    "Dokumen Internasional": "International Document",
    "Verifikasi Top Up": "Top Up Verification",
    "Approval Top Up": "Top Up Approval",
    "Manual Transaksi": "Manual Transaction",
    "Konfigurasi Batas Saldo": "Balance Limit Configuration",
    "Saldo Terakhir": "Last Balance",
    "Transaksi Saldo Nett": "Net Balance Transaction",
    "Konfigurasi Denda Saldo Minus": "Minus Balance Penalty Configuration",
    "Konfigurasi Top Up & Cashback": "Top Up & Cashback Configuration",
    "Konfigurasi Kuota Tiket CS": "CS Ticket Quota Configuration",
    "Automasi Indikasi DEX Palsu": "Fake DEX Indication",
    "Incoming & Outgoing": "Incoming & Outgoing",
    Pengumuman: "Announcement",
    "Konfigurasi Pesan": "Message Configuration",
    "Monitoring Integrasi API": "API Integration Monitoring",
    Middleware: "Middleware",
    "Konfigurasi Banner": "Banner Configuration",
    "Penghasilan COD": "COD Income",
    "Daftar Pick Up": "Pickup List",
    "Konfigurasi Jadwal Pick up": "Pickup Schedule Configuration",
    "Integrasi API": "API Integration",
    Laporan: "Report",
    "Unggah Data": "Upload Data",
    "Unduh Format & Data": "Download Format & Data",
    "Masukan & Saran": "Feedback",
    Notifikasi: "Notification",
    Keluar: "Log Out",
    Profil: "Profile",
    "Proses STIDEST SC": "STI DEST-SC Process",
    "DEX Asesmen L2": "Customer Service L2",
    "DEX Asesmen L1": "Customer Service L1",
    "Cari STT": "Search STT",
    "Manifest cari STT": "Search STT Manifest",
    "Manifest cari STT | Scan": "Search STT Manifest | Scan"
  },
  sttPaidUnpaid: {
    labelSearch: "Search",
    placeholderSearch: "Search STT No.",
    labelPaymentStatus: "Payment Status",
    placeholderPaymentStatus: "Select payment status",
    labelProcessStatus: "Process Status",
    placeholderProcessStatus: "Select process status",
    labelCityOrigin: "Origin City",
    placeholderCityOrigin: "Select origin city",
    labelCityDestination: "Destination City",
    placeholderCityDestination: "Select destination city",
    labelDateModified: "Date Modified",
    titleDateRange: "Payment Date",
    defaultDateRange: "Last 7 days",
    downloadStt: "Download STT",
    emptyData: "STT Paid/Unpaid data",
    colNoStt: "No. STT",
    colLastStatus: "Last Status",
    colPaymentStatus: "Payment Status",
    colPaymentDate: "Payment Date",
    colBookingDate: "Booking Date",
    colProcessStatus: "Process Status",
    colOriginCity: "Origin City",
    colDestinationCity: "Destination City",
    colDateModified: "Date Modified",
    statusPaid: "Paid",
    statusUnpaid: "Unpaid",
    statusCodPayment: "COD Payment",
    processStateProcessed: "Processed",
    processStateNotProcessed: "Not Processed",
    processStateNeedToPay: "Need to Pay",
    processStateNeedToCancel: "Need to Cancel",
    downloadFailed: "Download STT Failed!",
    totalNotification: "{total} new paid STTs"
  },
  sti: {
    pageTitle: "Station Transit In",
    searchPlaceholder: "Search Manifest ID",
    searchPlaceholderReverseScan: "Search Manifest ID",
    timeRangeDefault: "Last 7 days",
    updateButton: "Update STI",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    manifestId: "Manifest ID",
    no: "No.",
    action: "Action",
    actionArrange: "Arrange",
    detailTitle: "STI Manifest - {id}",
    printSti: "Print STI",
    dataUpdatedEvery10Min: "Data is updated every 10 minutes",
    refresh: "Refresh",
    totalUnprocessedSti: "Total unprocessed STI",
    partner: "Partner",
    stiCurrent: "Current STI",
    stiOverdue: "STI Overdue",
    unitStt: "STT",
    printSttNeedSti: "Print STT Pending STI",
    downloadSttNeedSti: "Download STT Pending STI",
    printRingkasan: "Print Summary",
    downloadExcelLower: "Download Excel",
    tanggalManifest: "Manifest Date",
    noStt: "No. STT",
    origin: "Origin",
    sttLabel: "STT",
    datePlaceholder: "Select date",
    needToSti: {
      pageTitle: "STT Pending STI",
      searchPlaceholder: "Search STT/bag/shipment no.",
      allPartner: "All Partner",
      filterNow: "Current",
      filterOverdue: "Overdue",
      download: "Download",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      noReferensi: "Reference No.",
      lastStatus: "Last Status",
      productType: "Product Type",
      totalPieces: "Total Pieces",
      totalWeight: "Total Weight",
      destinationCity: "Destination City",
      bookingDate: "Booking Date",
      partnerName: "Partner Name",
      deadline: "Deadline",
      overdue: "Overdue"
    },
    updateSti: {
      scanPromptEmpty: "Start entering/scanning STT numbers now.",
      searchPlaceholderBagStt: "Search Bag/STT no.",
      allPartner: "All Partner",
      packageMarker: "Package Marker",
      processManifest: "Process manifest",
      totalSttKoli: "Total STT/pieces",
      grossWeight: "Gross Weight",
      notFoundFilter: "Bag/STT number not found.",
      noPackageScanned: "No packages scanned yet.",
      modalConfirmMessage:
        "Some STT are not yet in STI. Continue process manifest?",
      modalConfirmSubtext:
        "If you continue, STT not yet in STI will be marked as STI overdue.",
      modalConfirmButton: "Yes, continue manifest",
      productType: "Product Type",
      partnerName: "Partner Name",
      podDeadline: "POD Deadline"
    }
  },
  stiDest: {
    searchPlaceholder: "Search Manifest ID",
    defaultTimeRange: "Last 7 days",
    updateStiDest: "Update STI-DEST",
    emptyData: "Station transit in destination",
    print: "Print",
    table: {
      no: "No.",
      manifestId: "Manifest ID",
      arrivalCity: "Arrival City",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      tanggalStiDest: "STI-DEST Date",
      action: "Action",
      noBag: "No. Bag",
      noStt: "No. STT",
      productName: "Product Name",
      commodityName: "Commodity Name",
      totalKoliShort: "Total Pieces",
      beratKotor: "Gross Weight",
      beratDimensi: "Volume Weight",
      origin: "Origin",
      dest: "Dest.",
      transit: "Transit",
      misroute: "Misroute",
      noReferensi: "Ref. No.",
      tanggalManifest: "Manifest Date",
      segeraPod: "Urgent POD",
      segeraRts: "Urgent RTS",
      segeraHal: "Urgent HAL",
      atur: "Actions"
    },
    tooltipArrivalCity:
      "Arrival city is where goods/STT arrive when processed in STI-DEST feature.",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    printRingkasan: "Print Summary",
    dataUpdatedEvery10Min: "Data updated every 10 minutes",
    refresh: "Refresh",
    dashboard: {
      headerBeforeStiDest: "Not yet STI-DEST, process now!",
      cargoPlaneTruckShip: "Cargo Plane {'|'} Truck {'|'} Ship",
      headerSttNowDel: "DEL due now!",
      headerSttOverdueDel: "DEL overdue, process now!",
      headerSttBar: "Priority to process today!",
      totalStt: "Total STT",
      tooltipSttAtConsolidator:
        "STT has arrived at Consolidator (STI DEST). Deliver now!",
      segeraPod: "Urgent POD",
      segeraRts: "Urgent RTS",
      segeraHal: "Urgent HAL",
      intracityIntercity: "Intracity / Intercity"
    },
    detail: {
      title: "Delivery Detail",
      partnerName: "Partner Name",
      userType: "User Type",
      arrivalCity: "Arrival City",
      detailStt: "STT Detail",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      tanggalDibuat: "Created Date",
      printStiDest: "Print STI-DEST",
      printSummary: "Print Summary",
      printPdf: "Print PDF",
      downloadExcel: "Download Excel"
    },
    update: {
      title: "Update STI-DEST",
      consolidatorName: "Consolidator Name",
      arrivalCity: "Arrival City",
      tooltipArrivalCity:
        "Arrival city is where goods/STT arrive when processed in STI-DEST feature.",
      tanggalStiDest: "STI-DEST Date",
      noStt: "No. STT",
      placeholderDate: "Select or enter vehicle serial no.",
      placeholderStt: "Enter STT No. or Scan Barcode/QR Code",
      labelStackedStt: "Example: 99LP1234567890123/88-22-12345678",
      add: "Add",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      process: "Process",
      updateStiDestAndPrintPdf: "Update STI-DEST & Print PDF",
      statusStiDest: "STI-DEST",
      statusMisroute: "MIS-ROUTE",
      statusTransit: "Transit",
      hapus: "Delete",
      hapusBarang: "Delete Item",
      deleteSttHint:
        "Enter STT No. or Scan Barcode/QR Code for item to remove from STI-DEST list.",
      terhapus: "Deleted",
      batal: "Cancel",
      sttNotFound: "STT number not found or already removed",
      sttAlreadyInput: "STT number already added"
    },
    needToStiDestDel: {
      title: "List must STI DEST & DEL",
      searchPlaceholder: "Search cargo & STT/shipment no.",
      cargoType: "Cargo Type",
      status: "Status",
      pilihStatus: "Select Status",
      reset: "Reset",
      terapkan: "Apply",
      saatIni: "Now",
      telat: "Overdue",
      download: "Download",
      noKargo: "Cargo No.",
      noStt: "No. STT",
      noReferensi: "Ref. No.",
      statusTerakhir: "Last Status",
      jenisPengiriman: "Service Type",
      totalKoli: "Total Pieces",
      totalBerat: "Total Weight",
      kotaAsal: "Origin City",
      tanggalUpdateStatus: "Status Update Date",
      batasWaktu: "Deadline",
      pilihTipeKargo: "Select Cargo Type",
      pesawat: "Plane",
      truk: "Truck",
      kapal: "Ship"
    },
    pdf: {
      manifestTitle: "STI-DEST Manifest",
      consolidatorName: "Consolidator Name",
      arrivalCity: "Arrival City",
      tanggalStiDest: "STI-DEST Date",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      produk: "Product",
      komoditas: "Commodity",
      totalKoliShort: "Total\nPieces",
      beratKotor: "Gross\nWeight",
      beratDimensi: "Volume\nWeight",
      origin: "Origin",
      dest: "Dest.",
      catatan: "Notes",
      kotaConsolidator: "Consolidator City",
      totalSttKoli: "Total STT/Pieces",
      beratKotorShort: "Gross Weight",
      tanggalManifest: "Manifest Date",
      noReferensi: "Ref. No.",
      jenisPengiriman: "Service Type",
      kotaAsal: "Origin City",
      penandaPaket: "Package Marker"
    }
  },
  shortland: {
    title: "Shortland",
    searchPlaceholder: "Search STT No. genesis/elexys",
    timeRangeCustom: "custom",
    timeRangeToday: "Today",
    timeRangeLast7Days: "Last 7 days",
    timeRangeLast14Days: "Last 14 days",
    downloadButton: "Download Shortland",
    emptyMessage: "No Shortland data to display",
    table: {
      no: "No.",
      cargoNo: "Cargo No.",
      cargoType: "Cargo Type",
      sttNoElexys: "STT No. Elexys",
      sttNoGenesis: "STT No. Genesis",
      sttNoPiecesGenesis: "STT No. Pieces Genesis",
      destinationCity: "Destination City",
      commodity: "Commodity",
      koli: "Koli",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    },
    csv: {
      no: "No",
      cargoNo: "Cargo No.",
      cargoType: "Cargo Type",
      sttNoElexys: "STT No. Elexys",
      sttNoGenesis: "STT No. Genesis",
      sttNoPiecesGenesis: "STT No. Pieces Genesis",
      sttNo: "STT No.",
      sttNoPieces: "STT No. Pieces",
      arrivalCity: "Arrival City",
      commodity: "Commodity",
      koli: "Koli",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    }
  },
  breadcrumb: {
    pusatResolusi: "Resolution Center"
  },
  notification: {
    searchPlaceholder: "Search messages",
    loading: "Loading.......",
    emptyNoResult: "No results found",
    emptyNoResultDescription:
      "What you are looking for was not found or does not exist.",
    emptyNoMessage: "No messages to display",
    mainNews: "Main News",
    download: "Download",
    filterNewest: "Newest",
    filterOldest: "Oldest",
    timezone: "WIB",
    sharedNewsPrefix: "shared a new announcement :",
    loginRequest: "Login Request",
    from: "from",
    reject: "Reject",
    accept: "Accept",
    actionAccepted: "Accepted",
    actionRejected: "Rejected",
    actionAcceptVerb: "accepted",
    actionRejectVerb: "rejected",
    loginRequestHandled:
      "Login request for <b>{accountName}</b> has been {action}.",
    okUpper: "OK",
    failedProcessTitle: "Failed to process",
    tryAgain: "Try again",
    back: "Back",
    confirmRejectTitle: "Reject login request?",
    confirmAcceptTitle: "Accept login request?",
    confirmRejectMessage:
      "Are you sure you want to reject this user's login request?",
    confirmAcceptMessage:
      "When accepted, the user will have access to Genesis.",
    confirmActionButton: "Yes, {action}",
    cancel: "Cancel"
  },
  integration: {
    title: "Generate New Token",
    subtitle: "Generate token to connect your app to Lion Parcel.",
    ok: "OK",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    copy: "Copy",
    generate: "Generate",
    contactHelp: "Is there a problem when generating token? Please contact",
    systemErrorTryAgain: "There was an error in our system, please try again",
    tryAgain: "Try Again",
    clientIdCopied: "Client ID successfully copied",
    clientSecretCopied: "Client Secret successfully copied",
    promptSuccess:
      "Token successfully created, please use it to connect app plugin.",
    promptExpired: "Client ID & Client Secret expired, please generate again.",
    errorGenerateMessage:
      "There was an error in our system, <br> please generate again.",
    errorGenerateTitle: "Token Generated Failed!"
  },
  manualStt: {
    searchPlaceholder: "Search STT number genesis",
    table: {
      noStt: "No. STT",
      clientPartnerName: "Client/Partner Name",
      clientPartnerCode: "Client/Partner Code",
      mixpack: "MIXPACK",
      createdAt: "Created Date",
      status: "Status",
      yes: "Yes",
      no: "No"
    },
    statusAll: "All Status",
    statusUsed: "Used",
    statusUnused: "Unused",
    emptyMessage: "Manual STT data",
    buttonGenerateStt: "Generate STT",
    placeholderSearchClientPartner: "Type or select client/partner",
    placeholderSearchClientBranch: "Type or select client branch",
    confirmLeave: {
      title: "Leave Page?",
      message:
        "You have not completed the form. Your request will not be processed if you leave this page.",
      leave: "Leave",
      back: "Back"
    },
    generate: {
      title: "Generate Manual STT",
      infoText:
        "Before proceeding with Auto Generate, please ensure the details are filled in correctly.",
      typeStt: "STT Type",
      clientPartner: "Client/Partner",
      amountStt: "STT Quantity",
      placeholderClientBranch: "Type or select client branch",
      placeholderClientPartner: "Type or select client/partner",
      placeholderAmount: "e.g 20",
      placeholderTypeStt: "Select STT Type",
      typeClient: "Client",
      typePartner: "Partner",
      back: "Back",
      autoGenerate: "Auto Generate",
      errorAmountMax: "STT quantity must not exceed {max}"
    },
    download: {
      title: "Download STT List",
      infoText:
        "Before downloading the manual STT list, please ensure the client/partner list is correct and matches the respective status.",
      labelClientPartner: "Client/Partner Name",
      placeholderClientPartner: "Type or select client/partner",
      labelStatus: "Status",
      statusAll: "All Status",
      statusUsed: "Used",
      statusUnused: "Unused",
      buttonDownload: "Download",
      successTitle: "Manual STT Download Successful!",
      successOk: "OK"
    },
    generateFailed: "Generate Failed!"
  },
  pusatResolusi: {
    tabEscalate: "Escalation tickets",
    tabMyTicket: "My tickets",
    tabFollowed: "Followed tickets",
    searchPlaceholder: "Search issue no./STT/shipment",
    escalatedBy: "Being escalated by {name}",
    refresh: "Refresh",
    filter: "Filter",
    filterReset: "Reset",
    filterCategory: "Category",
    filterSelectCategory: "Select category",
    filterStatus: "Status",
    filterTicketType: "Ticket type",
    filterClaim: "Claim",
    filterPriority: "Priority",
    filterApply: "Apply",
    sortOldest: "Oldest",
    sortNewest: "Newest",
    needToBeSolved: "Need to be solved",
    newMessage: "New message",
    mention: "Mention",
    needReview: "Need review",
    emptyInternet: "Internet disconnected",
    emptyServer: "System error occurred",
    emptyNoData: "No issues yet",
    emptySearchNotFound: "Issues not found",
    emptyInternetDesc: "Check your network connection.",
    emptyServerDesc: 'Click "Reload" or try again later.',
    emptyNoDataDesc: "Start by reporting your first issue.",
    emptySearchDesc: "Check or search for another issue no./STT/shipment id.",
    columnIssueNo: "Issue no.",
    columnSttShipment: "No. STT/shipment id",
    columnCategory: "Issue category",
    columnPriority: "Priority",
    columnStatus: "Status",
    columnCreatedAt: "Created at",
    columnAction: "Action",
    badgeNeedToSolve: "Need to be solved",
    badgeClaim: "Claim",
    tooltipReviewExpired: "Review period has ended",
    detail: {
      detailGoods: "Goods detail",
      grossWeight: "Gross weight",
      dimension: "Dimension",
      chargeableWeight: "Chargeable weight",
      koli: "Pieces",
      codCharge: "COD charge",
      goodsPrice: "Goods price",
      insurance: "Insurance",
      yes: "Yes",
      no: "No",
      commodity: "Commodity"
    },
    create: {
      reportIssue: "Report issue",
      issueType: "Issue type",
      sttLabel: "No. STT/shipment id",
      sttPlaceholder: "Enter STT/shipment no.",
      lastStatus: "Last status",
      check: "Check",
      reload: "Reload",
      category: "Issue category",
      selectCategory: "Select issue category",
      description: "Description",
      deleteDescription: "Remove description",
      descPlaceholder: "Enter description",
      submit: "Submit report"
    },
    detailPage: {
      updated: "Updated"
    },
    summaryTab: "Summary",
    detailInfoTab: "Detail information",
    modal: {
      reload: "Reload",
      systemError: "System error occurred",
      systemErrorMessage: 'Click "Reload" or try again later.'
    },
    review: {
      titleIssueNo: "Issue no. {ticketNo}",
      giveRating: "Rate this issue report!",
      ratingHint: "(thumb down = disappointing, thumb up = very satisfying)",
      reviewLabel: "Give your review",
      reviewPlaceholder: "Share your feedback on using Genesis",
      optional: "Optional",
      cancel: "Cancel",
      submit: "Submit"
    },
    finish: {
      title: "Add a comment before marking the issue as solved.",
      sendAndFinish: "Send & finish",
      cancel: "Cancel"
    },
    reopen: {
      title: "Please provide a reason before reopening the ticket",
      reopenTicket: "Reopen ticket",
      cancel: "Cancel"
    },
    success: {
      title: "Issue no. {noIssue} has been solved!",
      message: "Issue has been marked as solved.",
      ok: "OK, got it",
      toastSuccess: "Issue no. {noIssue} has been solved successfully."
    },
    history: {
      newMessagesAt: "{count} new messages at {time}.",
      viewMessages: "View messages",
      attachment: "Attachment",
      new: "New",
      today: "Today",
      yesterday: "Yesterday",
      csAgentOnDuty: "CS agent on duty",
      transferredTo: "transferred to",
      priorityChangedTo: "Ticket priority changed to",
      by: "by",
      categoryChanged: "Issue category",
      changedTo: "changed to",
      escalationTask: "Escalation task",
      completedBy: "completed by",
      ticketInEscalation: "in escalation",
      for: "for",
      ticket: "Ticket",
      madeByNew: "created by",
      madeBy: "by",
      systemError: "System error occurred",
      systemErrorDesc: 'Click "Reload" or try again later.',
      internetError: "Internet disconnected",
      internetErrorDesc: 'Check your connection then click "Reload".',
      reload: "Reload"
    },
    follow: {
      description: "Follow this issue to get updates and leave comments!",
      button: "Follow issue"
    },
    reply: {
      placeholder: "Reply",
      send: "Send"
    }
  },
  bookingCbp: {
    tabTitle: "Client CBP Booking List",
    banner:
      "<strong>IMPORTANT!</strong> Search and select client name first <strong>before creating manifest.</strong>",
    bannerSearchClientFirst:
      "<strong>IMPORTANT!</strong> Search and select client name first <strong>before creating manifest.</strong>",
    searchPlaceholder: "Search client name",
    placeholderSearchClient: "Search or select client name",
    createManifest: "Create Manifest",
    buttonCreateManifest: "Create Manifest",
    emptyHeader: "No Client CBP Booking List",
    emptyMessage: "Start creating Client CBP booking list and check it here",
    emptyListMessage: "No client CBP booking list yet",
    statusAll: "All",
    statusUnprinted: "Not yet manifested",
    statusPrinted: "Manifested",
    copySttTooltip: "Copy STT number",
    tooltipCopyStt: "Copy STT number",
    copyNotification: "STT number copied to clipboard",
    copySttSuccess: "STT number copied to clipboard",
    columnStt: "No. STT",
    columnStatusManifest: "Manifest status",
    errorPrintManifest: "Failed to Print Manifest!",
    sidebarMenuName: "Corporate Booking (CBP)",
    manifest: {
      posName: "POS Name",
      posCity: "POS origin city",
      pickUpDate: "Pick Up Date",
      clientName: "Client name",
      clientCity: "Client origin city",
      totalStt: "Total STT",
      totalPieces: "Total Pieces",
      totalWeight: "Total Gross Weight",
      docTitle: "CBP Client Manifest",
      origin: "Origin"
    }
  },
  verificationAccount: {
    passwordExpired: {
      title: "Password Has Expired",
      message: "Please reset your password to keep your account secure.",
      button: "Set password"
    },
    title: "Account Verification",
    description:
      "For account security, verify your {method} to reset your password",
    send: "Send",
    useOtherMethod: "Use another verification method",
    useMethodWith: "Use verification method with",
    email: "email",
    phoneNumber: "phone number",
    helpWhatsApp: "Need help? Contact via WhatsApp",
    orEmailTo: "or email to",
    chooseMethodTitle: "Choose Verification Method",
    methods: {
      partnerClientCode: "Partner/Client Code",
      partnerClientId: "Partner/Client ID",
      userEmail: "User Email",
      userPhone: "User Phone Number",
      partnerClientEmail: "Partner/Client Email",
      partnerClientPhone: "Partner/Client Phone Number"
    },
    captions: {
      partnerClientEmail: "partner/client email",
      partnerClientPhone: "partner/client phone number"
    },
    placeholders: {
      email: "e.g email{'@'}gmail.com",
      partnerClientCode: "Enter Partner/Client Code",
      partnerClientId: "Enter Partner/Client ID",
      yourPhoneNumber: "Enter your phone number"
    },
    otp: {
      title: "OTP Code Verification",
      description: "Enter the verification code sent via",
      userEmail: "User email",
      partnerClientEmail: "Partner/client email",
      partnerClientPhone: "Partner/client phone number",
      verify: "Verify",
      resendIn: "Resend OTP code in {countDown}",
      notReceivedCode: "Haven't received the code?",
      resend: "Resend",
      wrongCode: "The code entered is incorrect. Please check and try again."
    },
  },
  resetPasswordPage: {
    logoAlt: "logo",
    errorIconAlt: "warning icon",
    title: "Reset Password",
    newPasswordLabel: "New Password",
    newPasswordPlaceholder: "Enter password",
    confirmNewPasswordLabel: "Confirm New Password",
    confirmNewPasswordPlaceholder: "Enter password confirmation",
    passwordReuseError: "Password must not be the same as the previous password",
    submitButton: "Reset Password",
    back: "Back",
    tryAgain: "Try Again",
    ok: "OK",
    successModal: {
      title: "Password Changed!",
      message: "Your password has been changed"
    },
    rules: {
      minEightChars: "Password must be at least 8 characters",
      containsNumber: "Password contains a number",
      containsUppercase: "Password contains an uppercase letter",
      confirmPassword: "Confirm new password"
    },
    changeAccount: "Change Account",
    haveNoHub: "Don't have a Hub?",
    clickHere: "Click here",
  },
  revamp: {
    booking: {
      shippingRate: "Shipping rate",
      codAmount: "COD amount",
      heavyWeightSurcharge: "Heavyweight surcharge",
      totalPieces: "Total pcs",

      billedTo: "Billed to",
      paymentMethod: "Payment method",
      publishRatesShippingSurcharge: "Publish rates + shipping surcharge",
      originForwardRates: "Origin forward rates",
      destinationForwardRates: "Destination forward rates",
      totalShippingRates: "Total shipping rates",
      commoditySurcharge: "Commodity surcharge",
      heavyWeightAdditionalSurcharge: "Heavyweight surcharge",
      documentSurcharge: "Document surcharge",
      woodPackingSurcharge: "Wood packing surcharge",
      totalSurcharge: "Total surcharge",
      protectionFee: "Protection fee",
      protectionAdminFee: "Protection admin fee",
      codItemPrice: "COD item price",
      codCost: "COD amount",
      tacticalPromo: "Tactical promo",
      campaignPromo: "Campaign promo",
      totalRates: "Total rates",
      chargesPayableByRecipient: "Charges payable by recipient",
      taxEstimate: "Tax estimate",
      returnCost: "Return cost"
    }
  },
  handover: {
    manifest: {
      destinationCity: "Destination city",
      consolidatorName: "Consolidator name",
      handoverTo: "Handover to",
      handoverDate: "Created date",
      totalStt: "Total STT",
      admin: "Station admin",
      operationSupervisor: "Operations supervisor",
      totalSTT: "Total STT",
      totalPieces: "Total pieces",
      pieces: "Total\npieces",
      totalGrossWeight: "Total gross weight",
      totalDimensionWeight: "Total dimension weight",
      serviceType: "Product",
      commodity: "Commodity",
      grossWeight: "Gross\nweight",
      dimensionWeight: "Dimension\nweight",
      origin: "Origin",
      dest: "Dest.",
      note: "Notes",
      stationAdmin: "Station Admin",
      courier: "Courier",
      operationsSupervisor: "Operations Supervisor"
    },
    update: {
      handoverTo: {
        title: "Handover to",
        placeholder: "Type or select Vendor/Partner"
      },
      vendorName: {
        title: "Internal Vendor",
        placeholder: "Enter vendor name..."
      },
      sttNumber: {
        title: "STT No.",
        label: "Example: 99LP1234567890123/88-22-12345678",
        placeholder: "Enter STT No. or Scan Barcode/QR Code"
      },
      add: "Add",
      sttInfo: {
        totalStt: "Total STT",
        totalPieces: "Total Pieces",
        totalGrossWeight: "Total Gross Weight",
        totalDimensionWeight: "Total Dimension Weight",
        delete: "Delete",
        process: "Process"
      },
      table: {
        noRef: "Reference No.",
        product: "Product",
        commodity: "Commodity",
        pieces: "Total Pieces",
        weight: "Gross Weight",
        dimension: "Dimension Weight"
      },
      onUpdate: {
        titleSuccess: "Status Updated Successfully!",
        titleFailed: "Failed to Update Status!",
        messageSuccess: "STT status has been successfully updated to Handover.",
        messagePartial:
          "Some STT statuses were successfully updated to Handover, but some failed. Please download to view the errors.",
        messageFailed: "Failed to create Handover status update.",
        noSttSuccess: "Successful STT No.",
        noSttFailed: "Failed STT No."
      },
      leave: {
        title: "Are you sure you want to leave?",
        message:
          "Please double-check, you will lose all data if you leave this page.",
        textSuccess: "Leave",
        textCancel: "Back"
      },
      confirmation: {
        title: "Confirm Creation",
        message:
          "Please double-check, ensure all STT details are correct and accurate.",
        textSuccess: "Process",
        textCancel: "Back"
      },
      removePieces: {
        title: "Remove Item",
        message:
          "Enter STT No. or Scan Barcode/QR Code for <br /> the item you want to remove from the Handover list.",
        errorCaption: "STT No. not found/already deleted",
        removed: "Deleted",
        delete: "Delete",
        cancel: "Cancel"
      },
      process: {
        update: "Update Handover",
        print: "Update Handover & Print PDF"
      }
    },
    list: {
      title: "Vendor Handover (HND)",
      detail: {
        title: "Handover Manifest - {id}",
        shipmentDetails: "Shipment Details",
        sttDetails: "STT Details",
        partnerName: "Partner Name",
        userType: "User Type",
        totalStt: "Total STT",
        totalPieces: "Total Pieces",
        totalGrossWeight: "Total Gross Weight",
        totalVolumeWeight: "Total Volume Weight",
        handoverStatus: "Handover status",
        createdAt: "Created At",
        printHandover: "Print Handover",
        printSummary: "Print Summary",
        printPdf: "Print PDF",
        number: "No.",
        sttNo: "No. STT/Shipment.",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Vol. Weight",
        origin: "Origin",
        destination: "Destination",
        reason: "Reason",
        viewReason: "View reason",
        successTab: "Successful handover ({n})",
        failedTab: "Failed handover ({n})"
      },
      searchId: "Search Manifest ID",
      searchSubConsole: "Select Sub-Consolidator",
      update: "Update Handover",
      statusHandover: {
        SUCCESS: "Success",
        FAILED: "Failed",
        PARTIAL_SUCCESS: "Partial Success"
      },
      statusHitApi: {
        SUCCESS: "Response Success",
        FAILED: "Response Failed",
        PARTIAL_SUCCESS: "Partial Success",
        UNPROCESSED: "No Call API",
        IN_PROGRESS: "Process",
        NON_API: "No API"
      },
      table: {
        idManifest: "ID Manifest",
        handoverTo: "Destination vendor",
        stt: "Total STT",
        pieces: "Total Pcs",
        weight: "Total gross weight",
        dimension: "Total volume weight",
        date: "Handover Date",
        printSummary: "Print Summary",
        download: "Download Excel",
        action: "Manage",
        printVendor: "Print Vendor Receipt",
        printPdf: "Print PDF",
        statusHandover: "Handover status",
        statusHitApi: "API Response Status",
        viewDetail: "View details"
      },
      failedVendorModal: {
        title: "{n} STTs with Failed API Requests",
        sttNo: "STT/Shipment No.",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Dim. Weight",
        reason: "Reason",
        defaultReason: "No response from vendor",
        copiedReason: "Reason copied to clipboard",
        close: "Close"
      },
      retry: {
        menu: "Retry process",
        confirmTitle: "Retry handover process?",
        confirmBody:
          "The system will try to resend {n} failed STTs to the vendor.",
        confirmCancel: "Back",
        confirmSubmit: "Yes, retry",
        successTitle: "Handover processed successfully",
        successBody: "{n} STTs have finished the handover process.",
        successPrint: "Print manifest",
        successOk: "Okay",
        failedPrefix: "Failed to retry:",
        processTitle: "API Retry in Progress",
        processBody:
          "<strong>{n} STT</strong> are being reprocessed. Please wait until the process is complete.",
        processOk: "Ok",
        failedToast: "Failed to process API recall"
      },
      eligibilityModal: {
        title: "{n} STTs with Failed Handovers",
        sttNo: "STT No./Shipment",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Volume Weight",
        reason: "Reason",
        close: "Close"
      }
    }
  },
  handoverV2: {
    update: {
      common: {
        successScan: "Scan successful.",
        failedScan: "Scan failed.",
        failedApi: "Failed to scan STT/Shipment ID barcode.",
        failedScanDownloadTitle: "Failed scan list",
        failedNotFound: "STT not found",
        failedExist: "STT already exist",
        failedUnpaid: "STT not paid yet",
        sttNo: "STT Number",
        reason: "Reason",
        product: "Product",
        commodity: "Commodity",
        all: "All",
        back: "Cancel",
        save: "Save",
        ok: "Ok",
        printManifest: "Print manifest"
      },
      scan: {
        placeholder: "Enter or scan STT barcode/shipment ID",
        example: "Example: 99LP1234567890123/88-22-12345678",
        errorMax: "Maximum of {max} STTs can be scanned"
      },
      filter: {
        search: "Search No. STT/Shipment "
      },
      table: {
        sttNo: "No. STT/Shipment",
        piece: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Volume Weight",
        action: "Action",
        remove: {
          confirmTitle: "Delete STT {sttNo}?",
          confirmMessage: "Make sure you've selected the correct STT.",
          confirmButtonText: "Yes, delete",
          success: "STT {sttNo} successfully deleted."
        }
      },
      sidebar: {
        empty: {
          title: "No STT handed over yet",
          message: "Scan the STT barcode or Shipment ID to view vendor info."
        },
        changeVendor: "Change",
        placeholderInputVendorNameInternal: "Enter vendor name",
        totalStt: "Total STT",
        totalPieces: "Total Pieces",
        totalGrossWeight: "Total Gross Weight",
        totalVolumeWeight: "Total Volume Weight",
        processHandover: "Handover",
        cancel: "Cancel"
      },
      changeVendor: {
        title: "Change vendor",
        label: "Select vendor",
        placeholder: "Select vendor",
        success: "Vendor successfuly changed."
      },
      process: {
        confirmTitle: "Confirm handover process?",
        confirmMessage:
          "All scanned STT will be handed over to the destination vendor.",
        confirmButtonText: "Yes, process"
      },
      cancelProcess: {
        confirmTitle: "Cancel handover?",
        confirmMessage:
          "This will cancel the handover process for all scanned STT.",
        confirmButtonText: "Yes, next",
        success: "All STTs/shipments have been canceled for handover."
      },
      successProcess: {
        title: "Handover successful",
        message: "have been successfully handed over."
      },
      partialSuccessProcess: {
        title: "Handover partially successful",
        total: "Total",
        success: "Success",
        failed: "Failed"
      },
      errorProcess: {
        title: "Handover failed",
        message: "All STT failed to be handover."
      }
    }
  },
  cargoV2: {
    create: {
      index: {
        title: "CARGO Booking",
        manualBookingBtn: "Manual Booking",
        tab: {
          plane: "Plane",
          truck: "Truck",
          ship: "Ship"
        }
      },
      common: {
        backAlt: "back",
        selectSchedule: "Select Schedule",
        selectScheduleLower: "Select schedule",
        booking: "Booking",
        ok: "Ok",
        okUpper: "OK",
        kg: "kg"
      },
      nonRtcLayout: {
        title: "Manual booking"
      },
      rtc: {
        error: {
          getDetailRtc: "Failed to fetch RTC details",
          bookingFailed: "Cargo booking failed"
        }
      },
      rtcList: {
        emptyTitle: "Ready to Cargo List",
        notFound: {
          title: "No results found",
          message: "Check and reset your filters."
        }
      },
      searchFlightHeader: {
        totalKoli: "Total Pieces",
        grossVolume: "Gross w./ Volume w.",
        alt: {
          plane: "Plane",
          briefcase: "Briefcase",
          box: "Box"
        }
      },
      searchFlight: {
        title: "Select schedule",
        reload: "Reload",
        status: {
          loading: {
            header: "Loading flight schedules",
            body: "We are looking for the best schedule for you."
          },
          server: {
            header: "System issue occurred",
            body: "Please try again later"
          },
          internet: {
            header: "Internet connection lost",
            body: "Please check your internet connection"
          },
          filteredEmpty: {
            header: "No results found",
            body: "Check and reset your filters."
          },
          empty: {
            header: "No flight schedules available",
            body: "Change date or filters to find other flight schedules"
          }
        },
        error: {
          networkTitle: "Booking failed!",
          bookingFailed: "Booking failed"
        }
      },
      modal: {
        bookingProcessing: {
          title: "Cargo booking {bookingRequestId} <br/> Is being processed",
          message:
            "You will receive a notification when the cargo booking is successful"
        },
        bookingFailed: {
          title: "Booking failed",
          message:
            "Cargo with <b>route {origin} - {destination}</b> failed to book because {reason}. Please try again later!"
        }
      },
      snackbar: {
        booked:
          "Cargo <b>{cargoNo}</b> to {destination} has been booked successfully."
      },
      error: {
        failedToCargoBooking: "Failed to Cargo Booking !",
        creationFailed: "Creation Failed !",
        bookingFailedTitle: "Booking Failed !"
      }
    },
    components: {
      common: {
        backAlt: "back",
        closeAlt: "close",
        transportAlt: "transport",
        infoAlt: "info",
        save: "Save",
        cancel: "Cancel",
        reset: "Reset",
        apply: "Apply",
        booking: "Booking",
        all: "All",
        process: "Process",
        back: "Back",
        completeBookingData: "Complete booking data",
        destinationCity: "Destination city",
        destinationCityTitle: "Destination City",
        selectDestinationCity: "Select destination city",
        transportMode: "Mode",
        selectMode: "Select mode",
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        kg: "kg",
        kgCapital: "Kg",
        vehicleSerialNumber: "Vehicle serial number",
        searchVehicleSerialNumber: "Search vehicle serial number",
        commodity: "Commodity",
        selectCommodity: "Select commodity",
        product: "Product",
        selectCargoProductType: "Select cargo product type",
        cargoNumber: "Cargo Number",
        nog: "NOG",
        inputNog: "Input NOG",
        nogTooltip: "Fill NOG according to the cargo commodity.",
        shc: "SHC",
        selectShc: "Select shc",
        shcTooltip:
          "SHC will be filled automatically based on the selected cargo commodity.",
        other: "Other",
        errorGetData: "Failed to get data!",
        plane: "Plane",
        truck: "Truck",
        ship: "Ship",
        confirmCreationTitle: "Creation Confirmation",
        confirmCreationMessage:
          "Please make sure all STT details are correct and appropriate."
      },
      editLayout: {
        title: "Edit cargo"
      },
      sectionSelectDestCargoType: {
        error: {
          getCity: "Failed to get city data",
          getCargoType: "Failed to get cargo type data"
        }
      },
      cardRtc: {
        minimumPiecesWeight: "Minimum pieces & weight",
        minimumPieces: "Minimum pieces",
        minimumWeight: "Minimum weight",
        bosspackProduct: "Bosspack cargo product",
        departurePlusTwoDays: "Departure +2 days",
        departurePlusTwoDaysTooltip:
          "Departure estimation has not been configured for the next 2 days. Please select a schedule",
        departureStart: "Departure starts:",
        totalPieces: "Total Pieces",
        totalPiecesTooltip: "Total cargo pieces (STT and bag)",
        grossWeight: "Gross w.",
        grossWeightTooltip: "Total cargo gross weight (STT and bag)"
      },
      searchFlightFilter: {
        airport: "Airport",
        selectAirport: "Select airport",
        originAirport: "Origin airport",
        destinationAirport: "Destination airport",
        transitCount: "Transit count",
        selectTransitCount: "Select transit count",
        sort: "Sort",
        sortFrom: "Sort from",
        searchTimeLimit: "Search time limit",
        timeLimit: "Time limit",
        origin: "origin",
        destination: "destination",
        legs: {
          direct: "Direct",
          oneTransit: "1 transit",
          twoTransit: "2 transits",
          moreThanThreeTransit: ">3 transits"
        },
        sortOption: {
          etaFastest: "Fastest ETA",
          etdFastest: "Fastest ETD"
        },
        threshold: {
          twelveHours: "12 hours from now",
          twentyFourHours: "24 hours from now"
        }
      },
      modalDelayConfirmation: {
        title: "Make sure the selected schedule is correct",
        transit: "{count} Transit",
        flightRoute: "FLIGHT ROUTE",
        estimatedDeparture: "ESTIMATED DEPARTURE",
        body:
          "This flight schedule has <span class=\"font-bold\">potential delay</span>, do you want<br />to continue booking?",
        changeSchedule: "Change schedule",
        confirmBooking: "Yes, Book"
      },
      cardFlight: {
        arrivalDayDiff: "+{count} day",
        volumeUnavailable: "Aircraft volume is insufficient",
        dimensionUnavailable: "Aircraft dimension is insufficient",
        capacityUnavailable: "Aircraft capacity is insufficient",
        embargoRoute: "Embargo Route",
        dgNotAllowed: "Cannot send DG goods",
        potentialDelay: "Potential delay",
        onTime: "On-time",
        availableCapacity: "Available capacity",
        flyIn: "Fly in",
        flyInValue: "{hours} hours {minutes} minutes",
        viewTransitDetail: "View transit details",
        close: "Close",
        direct: "Direct",
        originCity: "Origin city",
        destinationCity: "Destination city",
        transit: "Transit {count}",
        capacity: "Capacity"
      },
      modalPlaneAuto: {
        commodityGroup: "Commodity Group (Cargo)",
        productType: "Cargo product type"
      },
      modalBookingTruck: {
        error: {
          getCourierData: "Failed to get courier data"
        }
      },
      modalBookingShip: {
        inputCargo: "Input cargo"
      },
      manualInput: {
        cargoNumberManual: "Manual cargo/SMU number",
        inputCargoNumberManual: "Input manual cargo/SMU number",
        track: "Track",
        cargoNumberTooltip:
          "SMU number is required if booking is done in an external system. The SMU number contains the airline code and a unique number",
        checkInternet: "Please check your internet connection!",
        selectProduct: "Select Product",
        errorGetCourierData: "Failed to get courier data",
        flightDuration: {
          minutes: "{count} minutes",
          hours: "{count} hours",
          hoursMinutes: "{hours} hours {minutes} minutes"
        }
      },
      inputVehicleNo: {
        placeholder: "ABCD 123",
        invalidFormat: "Invalid format"
      },
      photoDispute: {
        infoAlt: "Info",
        title: "PHOTO PROOF IS REQUIRED",
        viewPhoto: "View photo",
        guide: {
          clearPhoto: "Photo must be clear and not blurry.",
          readableWeightVolume: "Weight/volume numbers must be clearly readable.",
          fullCargoFrame: "All cargo must be visible in one frame."
        },
        photoType: {
          weighingAndCargo: "Scale + Cargo",
          additionalPhoto: "Additional photo"
        },
        error: {
          upload: "Failed to upload dispute photo",
          delete: "Failed to delete dispute photo"
        }
      },
      cargoDisputeForm: {
        pieces: "Pieces",
        stt: "STT",
        bag: "bag",
        reweighTitle: "Reweigh",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w.",
        chargeableWeight: "Chargeable w.",
        grossWeightCargo: "Cargo gross w.",
        maxGrossWeightCargoTooltip:
          "Maximum cargo gross w. for {cargoType}: {maxWeight} kg",
        maxWeight: "Maximum {maxWeight} kg",
        cargoPieces: "Cargo pieces",
        maxCargoPiecesTooltip:
          "Maximum cargo pieces for {cargoType}: {maxPieces}",
        maxPieces: "Maximum {maxPieces} pieces",
        cargoDimension: "Cargo dimensions",
        dimension: "L x W x H",
        editIfDimensionChanged: "Edit if dimensions change",
        cargoVolumeWeight: "Cargo volume w.",
        maxCargoVolumeWeightTooltip:
          "Maximum cargo volume w. for {cargoType}: {maxWeight} kg",
        calculating: "Calculating ...",
        cargoChargeableWeight: "Cargo chargeable w.",
        cargoType: {
          plane: "plane",
          truck: "truck",
          ship: "ship"
        },
        error: {
          baggingWeightLocked: "Weight cannot exceed reweigh result",
          baggingWeightLockedTooltip:
            "Weight cannot be changed because it follows the bagging result.",
          maxCargoChargeableWeightDiff:
            "Maximum cargo CW difference is {maxWeight} kg per STT",
          chargeableWeightDifference: "Cargo CW difference >= 1 kg"
        }
      },
      scanTableList: {
        emptyStateAlt: "Empty State",
        empty: "No scanned packages yet.",
        delete: "Delete",
        column: {
          no: "No.",
          bagNo: "Bag No.",
          chargeableBag: "Chargeable w. bag",
          sttNo: "STT No.",
          chargeableStt: "Chargeable w. STT",
          shippingType: "Shipping type",
          commodity: "Commodity",
          destinationCity: "Destination city",
          action: "Action"
        }
      },
      scanTableSection: {
        inputPlaceholder: "Input shipment/STT/bag",
        invalidSttTitle: "Invalid STT",
        total: "Total {count}",
        scanProcessFailed: "Failed to process scan",
        bagAlreadyExists: "Bag already exists in the table",
        sttAlreadyExists: "STT already exists in the table",
        weightExcess:
          "Excess weight occurred so the status cannot be updated to Cargo.",
        export: {
          sttNumber: "STT Number",
          failedReason: "Failure Reason"
        },
        deleteModal: {
          title: "Are you sure you want to delete the data?",
          message: "The data will automatically be removed from the table list.",
          confirm: "Yes, Delete"
        }
      },
      detailHistory: {
        title: "Cargo status history",
        empty: "Oops.. No data to display yet",
        proofOfDelivery: "View proof of delivery",
        proofWeightAdjustment: "View proof photo of weight adjustment",
        totalPieces: "Total pieces",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w."
      },
      detailInfo: {
        bookingDate: "Booking date",
        lastUpdated: "Last updated",
        inProcessBooking: "Booking in process",
        cancelledOrFailedBooking: "Cancelled/booking failed",
        printStatus: "Print Status",
        weightDispute: "Weight dispute",
        manualCargoNumber: "Manual cargo/SMU number",
        sttWeight: "STT weight",
        reweighWeight: "Reweigh weight",
        cargoWeight: "Cargo weight",
        grossWeight: "Gross W.",
        volumeWeight: "Volume W.",
        chargeableWeight: "Chargeable W.",
        grossWeightCargo: "Cargo Gross W.",
        cargoPieces: "Cargo pieces",
        volumeWeightCargo: "Cargo Volume W.",
        totalSttBag: "Total STT/Bag",
        chargeableWeightCargo: "Cargo Chargeable W.",
        weightDisputeBag: "Weight dispute bag",
        pieces: "pieces",
        stt: "STT",
        bag: "bag",
        photoProofAlt: "Weight adjustment proof photo piece {index}",
        viewMorePhotoProof: "View {count} more proof photos",
        sttBagList: "STT/bag list",
        emptySttBag: "There are no STT or bagging items in this cargo",
        disputeBagTooltip: "Bag with weight dispute",
        viewProofPhoto: "View proof photo",
        processedByBagging: "Processed by bagging",
        processedByCargo: "Processed by cargo",
        print: {
          labelCargo: "Cargo label",
          awbLionCargo: "Lion Cargo AWB",
          manifestCargo: "Cargo manifest"
        }
      },
      disputeSummary: {
        withWeightDispute: "with weight dispute",
        dataRange: "Data {dateRange}",
        download: "Download",
        minimumWeightPerPiece: "SMU with minimum weight per piece",
        error: {
          downloadSummary: "Failed to download dispute summary data!",
          downloadMinimumWeight: "Failed to download minimum weight data!"
        }
      },
      filterSection: {
        searchPlaceholder: "Cargo no./SMU",
        destinationAirportCode: "Destination airport code",
        hubLocation: "HUB Location",
        filter: "Filter",
        selectDate: "Select date"
      },
      downloadList: {
        title: "Create cargo list",
        startBookingDate: "Booking start date",
        inputStartDate: "Input start date",
        endBookingDate: "Booking end date",
        inputEndDate: "Input end date",
        hubLocation: "Hub location",
        selectHubLocation: "Select hub location",
        bookingUser: "Booking user",
        selectBookingUser: "Select booking user",
        downloadFailed: "Download Failed!"
      },
      searchFlightDatePicker: {
        selectOtherDate: "Select another date"
      },
      buttonLoadMore: {
        label: "View more"
      },
      filterRtc: {
        client: "Client",
        selectDestinationCity: "Select destination city",
        searchDestinationCityHere: "Search destination city here",
        notFound: "What you are looking for was not found or does not exist.",
        selectClient: "Select client",
        searchClientHere: "Search client here",
        selectMinimumLimit: "Select minimum limit",
        minimumWeight: "Minimum weight",
        minimumPieces: "Minimum pieces",
        minimumWeightAndPieces: "Minimum weight & pieces",
        destinationCitiesSelected: "destination cities selected",
        clientsSelected: "clients selected",
        cotNearest: "Nearest COT",
        cotLongest: "Longest COT"
      }
    }
  },
  bulkBooking: {
    repair: "Repair",
    booking: "Booking",
    invalidShipmentId: "Invalid Shipment ID",
    bookingFailed: "Booking Failed!",
    manualSttMinimum: "Manual STT number must contain at least 3 digits.",
    deleteRepairFailed: "Failed to delete failed booking repair!",
    repairDetailFetchFailed: "Failed to load repair booking details!",
    codConfigurationFailed: "Failed to get COD configuration!",
    editCustomerNameInvalid: "Invalid name. Please try again.",
    editCustomerAddressInvalid: "Invalid address. Please try again.",
    uploadActivityFailedTitle: "Upload Activity Failed",
    uploadActivityFailedMessage: "Activity “{fileName}” failed to upload",
    searchPlaceholder: "Search upload ID or name",
    uploadBulkBooking: "Upload Bulk Booking",
    columnUploadId: "Upload ID",
    columnNamaAktivitas: "Activity name",
    columnTipeBerkas: "File type",
    columnNamaBerkas: "File name",
    columnStatus: "Status",
    columnDibuatUntuk: "Created for",
    columnTanggalDibuat: "Date created",
    columnAtur: "Manage",
    columnTipeBooking: "Booking type",
    columnNamaFile: "File name",
    columnCatatan: "Notes",
    statusSuccess: "Successful",
    statusFailed: "Failed",
    statusPartially: "Partial",
    statusUploading: "Uploading",
    repairedCount: "Successfully repaired",
    downloadSuccessFile: "Download successful file",
    downloadFailedFile: "Download failed file",
    downloadOriginalFile: "Download original file",
    repairFailedBooking: "Failed to repair booking",
    repairBannerFailed: "There are {count} failed records. Repair and edit them.",
    printStt: "Print STT",
    bookingUlang: "Book Again",
    resubmitBooking: "Resubmit Booking",
    emptyState: "Bulk Booking",
    emptyStateFailed: "Failed Booking",
    downloadTemplate: "Download Template",
    bulkPrintResiThermal: "Bulk Print Thermal Receipt",
    bulkPrintResiBasic: "Bulk Print Basic Receipt",
    columnTotalStt: "Total STT",
    actionMore: "More",
    saveSenderDetail: "Save sender details",
    saveRecipientDetail: "Save recipient details",
    vendorNinjaInfo: "A maximum of 1 piece is allowed for the selected destination",
    deleteBooking: "Delete this booking",
    clientName: "Client Name",
    filterClientName: "Filter client search",
    cityOriginClient: "Client origin city (3LC)",
    insertName: "Enter and select client origin city (3LC)",
    serviceType: "Shipping Service Type",
    chooseType: "Select shipping service type",
    insertAlias: "Enter and select the branch client name, alias, or code",
    clientNameMustInsert: "Client name is required",
    clinetNotBook: "Client cannot make a booking",
    clientList: "Client List",
    searchbyName: "Search by client name or alias",
    originCity: "Origin City",
    clientType: "Client Type",
    service: "Shipping Service",
    clientCode: "Client Code",
    districtRequired: "District and origin city are required",
    errormessageName: "Sender name must contain at least 3 characters.",
    messageNameRequired: "Sender name is required.",
    senderAddress3: "Sender address must contain at least 3 characters.",
    senderAddressReq: "Sender address is required.",
    phoneNumberInvalid: "Invalid phone number. Please try again.",
    sender: "Sender",
    home: "Home",
    recepientNameError: "Recipient name must contain at least 3 characters.",
    repientNameReq: "Recipient name is required.",
    recipientNameError: "Recipient name must contain at least 3 characters.",
    recipientNameReq: "Recipient name is required.",
    recAddresMin3: "Recipient address must contain at least 3 characters.",
    recAddresReq: "Recipient address is required.",
    download: "Download",
    form: {
      goodsCategory: "Goods category",
      phoneNumberExample: "Example: 8123456789012",
      weightExample: "e.g. 20",
      totalPiecesPerPackage: "Enter total pieces per package",
      nextCommodity: "Next commodity",
      nextCommodityPlaceholder: "Enter next commodity",
      externalReferenceExample: "DOR00989",
      termsAndConditions: "terms and conditions.",
      nextCommodityHint: "Enter the commodity contained in one package.",
      nextCommodityRequired: "Next commodity is required",
      totalPiecesPerPackageRequired: "Total pieces per package is required",
      taxNumberInvalid: "Enter a valid tax identification number",
      shipmentStatusRequired: "Shipment status is required."
    },
    estimation: {
      publishRate: "Publish rate + shipping surcharge",
      originForwardRate: "Origin forward rate",
      destinationForwardRate: "Destination forward rate",
      codGoodsValue: "COD goods value",
      codFee: "COD fee",
      promotion: "Promotion",
      off: "Off",
      until: "until"
    },
    filter: {
      label: "Filter",
      uploadStatus: "Upload status",
      fileType: "File type",
      createdFor: "Created for",
      placeholderUploadStatus: "Select upload status",
      placeholderFileType: "Select file type",
      placeholderClientPos: "Select client/POS",
      reset: "Reset",
      apply: "Apply",
      statusSuccess: "Successful",
      statusPartially: "Partial",
      statusFailed: "Failed",
      statusUploading: "Uploading",
      typeClient: "Client",
      typeRetail: "Retail"
    },
    create: {
      uploadFileTitle: "Upload file",
      bookingTypeRetail: "Retail",
      bookingTypeClient: "Client",
      clickToUpload: "Click to upload",
      uploadHint: "Format .xlsx, max. {maxFileMb} MB and {maxStt} STT.",
      uploadHintLimit: "Only the first {maxStt} data columns will be processed",
      activityName: "Activity name",
      placeholderActivityName: "Enter activity name",
      activityNamePlaceholder: "Enter a name or note for this activity",
      changeFile: "Change",
      upload: "Upload",
      downloadTemplate: "Download template",
      downloadTemplateHint:
        "Download the booking template, complete the data according to the instructions, then upload your file.",
      templateInternational: "International booking",
      templateDomestic: "Domestic booking",
      templateRetailInternational: "Retail international booking",
      templateRetailDomestic: "Retail domestic booking",
      templateClientInternational: "Client international booking",
      templateClientDomestic: "Client domestic booking",
      checkFormatTitle: "Check the data format in each column",
      checkFormatHint:
        "Before uploading bulk bookings, ensure that all data in each column matches the required format.",
      infoBadgeInterpackFtz:
        "Currently unavailable for INTERPACK and Free Trade Zone shipment types.",
      commodityData: "Commodity data",
      districtData: "District data",
      title: "Upload Bulk Booking",
      fileType: "File type",
      retail: "Retail",
      client: "Client",
      uploadFile: "Upload File",
      change: "Change",
      validationChars: "characters",
      templateRetail: "Retail booking template",
      templateClient: "Client booking template",
      dataCommodity: "Commodity data",
      dataDistrict: "District data",
      downloadTemplateDescription:
        "Download the template, fill in the data columns, check the format, and upload it here!",
      checkFormat: "Check the data format in each column",
      checkFormatDescription:
        "Before uploading bulk bookings, ensure that all data in each column matches the format below!",
      modalProcessingTitle: "Bulk booking is being processed!",
      modalProcessingMessage:
        'Booking "{name}" is in progress. Please wait a moment.',
      modalFailedUploadMessage:
        'Booking "{name}" was unsuccessful. Please upload the file again.',
      modalSuccessTitle: "OK",
      uploadSuccessTitle: "Bulk booking uploaded successfully",
      download: "Download",
      booking: "Book",
      modalErrorRowEmpty: "There is an empty row!",
      modalErrorDataExceed: "Booking data exceeds the limit!",
      modalErrorHeaderInvalid: "Invalid file header!",
      modalErrorRowEmptyAlt: "There is an empty row!",
      modalErrorQueueFull: "Bulk booking queue is full",
      modalErrorFileSize: "Bulk booking file exceeds {size} MB",
      modalErrorSystem: "A system issue occurred",
      modalSubtitleRowEmpty: "Check the file, complete all rows, and upload it again.",
      modalSubtitleDataExceed:
        "The maximum is 100 rows. Remove some uploaded data.",
      modalSubtitleHeaderInvalid:
        "Check the file and re-upload it using the template format.",
      modalSubtitleRowEmptyAlt:
        "Check the file, complete all rows, and upload it again.",
      modalSubtitleQueueFull: "Please wait a moment and try again.",
      modalSubtitleFileSize: "Change the file and upload it again.",
      modalSubtitleSystem: 'Click "Reload" or wait a moment.',
      btnUploadAgain: "Upload again",
      btnReload: "Reload",
      btnUnderstand: "OK, I understand",
      btnBack: "Back",
      uploadFileCaption:
        "Format .xlsx. Maximum {maxStt} STT and {maxMb} MB file.<br/>Only the first 500 data rows will be processed.",
      uploadFileErrorFormat: "Invalid file format"
    },
    modal: {
      delete: "Yes, delete",
      back: "Back",
      deleteTitle: "Delete booking ({value})?",
      deleteMessage: "Your shipment will not be processed if you delete this booking.",
      successDeleteTitle: "Failed booking repair was deleted successfully!",
      successDeleteMessage: "You can still create a new shipment with bulk booking.",
      successTitle: "Booking successful ({value})",
      done: "Done",
      nextBooking: "Next booking",
      printThermalReceipt: "Print thermal receipt",
      productType: "Shipment Type",
      deliveryEst: "Estimated delivery",
      recipient: "Recipient",
      districtCity: "District, destination city",
      codCost: "COD Fee",
      mustPaid: "Amount to be paid by recipient",
      totalTariff: "Total tariff"
    },
    edit: {
      confirmDeleteTitle: "Delete booking",
      confirmDeleteMessage: "Your shipment will not be processed if you delete this booking.",
      successDeleteTitle: "Failed booking repair was deleted successfully!",
      successDeleteMessage: "You can still create a new shipment with bulk booking."
    },
    filterStatus: {
      parent: "Select status upload",
      success: "Success",
      partially: "Partially",
      failed: "Failed",
      uploading: "Uploading"
    }
  },
  cargo,
  setupPassword: {
    title: "Set Up New Account Password",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    submitButton: "Set password",
    rules: {
      eightChars: "Password must be at least 8 characters",
      containsNumber: "Password must contain a number",
      containsUppercase: "Password must contain an uppercase letter",
      noGenesis: "Must not contain the word 'genesis'",
      passwordMatch: "Confirm new password"
    },
    helpWA: "Need help? Contact via WhatsApp",
    helpEmail: "or email to",
    success: {
      title: "New Password Saved",
      message: "You can now use your new password to login to Genesis.",
      button: "Login"
    },
    loginGenesis: "Login to Genesis",
    urlUsed: "Link Has Been Used",
    messageUsed:
      "You have set a new password. Please log in to Genesis <br /> with your new password.",
    urlInvalid: "Link is no longer active",
    messageInvalid: "Please contact the helpdesk team for further assistance.",
    expired: {
      title: "Link Has Expired",
      description:
        "Please click the button below to re-request the new password <br /> setup link.",
      requestNewUrl: "Request New Link",
      success: "New link has been sent"
    },
    placeholderPassword: "Input password",
    placeholderConfirmPassword: "Input confirmation password",
    error: {
      title: "Failed to Create New Password",
      message:
        "A server error occurred while processing your request. Please try again later.",
      button: "OK"
    }
  },
  forgotPassword: {
    title: "Forgot Password",
    hint: "Don't worry! Input your email address to reset your password",
    emailPlaceholder: "Input email",
    submitButton: "Reset Password",
    backToLogin: "Back to Log In",
    errorEmptyEmail: "Input your email !",
    errorInvalidEmail: "Your email is incorrect or not registered. Try again",
    modalSuccessTitle: "Request Accepted!",
    modalSuccessMessage: "Link to reset your password has been sent to {email}",
    modalFailTitle: "Unable to Change Password",
    modalFailMessage:
      "Account with email {email} has changed password 3 times. Contact Lion Parcel for further details",
    expired: {
      title: "Expired Link",
      body: "Link to request a new password has expired. Access has exceeded 1 x 24 hours. Please make a new request or contact Lion Parcel Customer Service.",
      backButton: "Back to Genesis"
    }
  },
  inactiveAccount: {
    title: "Your Account Has Been Deactivated",
    body:
      "For security, accounts with no activity for 30 days are temporarily deactivated. Please contact our Helpdesk to reactivate your account.",
    helpPrefix: "Need help? Contact via:",
    helpWhatsApp: "WhatsApp",
    helpEmail: "Email"
  },
  loginErrorModal: {
    title: "Login failed",
    tryAgain: "Try again",
    close: "Close"
  },
  pickup: {
    activePickupWarning: {
      title: "Continue with a new Pick Up request?",
      body:
        "The system will add the new shipment while the previous shipment remains active.",
      buttonBack: "Back",
      buttonConfirm: "Continue"
    },
    bookingSummary: {
      titleSuggestion: "Recommended to pick up",
      titleBucket: "Ready to pick up",
      changeAddress: "Change address",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Nearest schedule:",
      viewStt: "View STT",
      viewActivePickup: "View active Pick Up {count}",
      empty:
        "Pickup request data is unavailable. Please create the pickup manually",
      createManual: "Create Pick Up Manually",
      piece: "pcs",
      wood: "WOOD",
      addressIsEmpty: "No pick-up address has been added.",
      addAddress: "Add address"
    },
    printLabel: "Print label",
    cancel: {
      button: "Cancel",
      confirm: {
        title: "Are you sure you want to cancel the shipment?",
        instruction: "Enter the cancellation reason before proceeding.",
        reasonPlaceholder: "Cancellation reason",
        back: "Cancel",
        continue: "Continue",
        charCounter: "{current}/{max}"
      },
      success: {
        title: "Shipment successfully cancelled",
        body: "The shipment cancellation has been successfully processed.",
        close: "Close"
      },
      failed: {
        title: 'Failed to cancel "{shipmentId}"',
        body: "Pick up cancellation failed. Please check and try again.",
        back: "Back",
        retry: "Retry"
      },
      sidebar: {
        reasonLabel: "Cancellation reason"
      }
    },
    scheduleConfig: {
      pageTitle: "Set Pick Up schedule",
      breadcrumb: {
        parent: "Pick Up Schedule Configuration"
      },
      sidebar: {
        addressTitle: "Pick Up Address",
        changeAddress: "Change address",
        addAddress: "Add address",
        saveSchedule: "Save schedule",
        defaultBadge: "Primary",
        coordinatesLabel: "Coordinate point:",
        empty: "No saved address yet"
      },
      shipment: {
        sectionTitle: "Shipment Information",
        clientLabel: "Client",
        estimateAdditionalKoli: "Estimated additional pieces",
        estimateWeight: "Estimated weight",
        weightSuffix: "kg",
        serviceType: "Shipping type",
        placeholderKoli: "Enter estimated additional pieces",
        placeholderWeight: "Enter estimated weight",
        placeholderService: "Select shipping service"
      },
      clientSelector: {
        title: "Select Client",
        fieldLabel: "Client",
        fieldPlaceholder: "Select client",
        continueButton: "Continue",
        clientPlaceholder: "Select client",
        continue: "Select",
        cancel: "Cancel"
      },
      scheduleSectionTitle: "Pick Up Schedule",
      regular: {
        title: "Regular schedule",
        tooltip:
          "The latest Pick Up schedule will be applied starting tomorrow.",
        maxSlotsNote: "(Max. 3 schedules per day.)",
        addTime: "Add time",
        emptySlots: "No time selected",
        popoverTitle: "Select Pick Up time",
        durationFooter: "Duration 1 hour",
        duplicateTime: "This time has already been added",
        confirmTime: "Select",
        emptyTimeOptions: "No time options available",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        }
      },
      special: {
        modalTitle: "Select Pick-up schedule",
        pickDateLabel: "Select date",
        pickTimeLabel: "Select time",
        save: "Save",
        duplicateDate: "This date has already been added",
        modalMaxSlotsNote: "Max. 3 schedules per day.",
        title: "Special schedule",
        tooltipTitle: "Special Schedule",
        tooltipDescription:
          "Special schedules will override regular schedules on the selected dates.",
        maxDatesNote: "(Max. 3 dates.)",
        addDate: "Select Pick-up date",
        reset: "Reset",
        addTime: "Add time"
      },
      successModal: {
        title: "Pick Up schedule successfully saved",
        description: "Configuration saved & will be applied starting tomorrow.",
        buttonClose: "Close"
      },
      successNotification: "Pick Up schedule successfully saved",
      leaveModal: {
        title: "Leave from this page?",
        description: "All changes will be discarded if you leave.",
        buttonCancel: "Stay here",
        buttonConfirm: "Yes, leave"
      }
    },
    requestSuccess: {
      title: "Pick Up request sent",
      description: "Pick Up request with Order ID",
      description2: " has been created.",
      summary: {
        totalLabel: "Total request",
        totalValue: "{totalKoli} pcs • {totalWeightKg} kg",
        dateLabel: "Pick Up date",
        timeLabel: "Pick Up time"
      },
      button: {
        close: "Close",
        viewDetail: "View shipment detail"
      }
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Create Manual Pick Up"
      },
      banner: {
        sttPrefix: "You have ",
        sttSuffix: " Airway Bill that can be processed.",
        viewAll: "View all"
      },
      field: {
        clientLabel: "Client",
        clientPlaceholder: "Select client",
        addressLabel: "Pick Up address",
        koliLabel: "Estimated pcs",
        koliPlaceholder: "Enter pcs",
        weightLabel: "Estimated weight",
        weightPlaceholder: "Enter weight",
        weightUnit: "kg",
        serviceLabel: "Shipping service",
        servicePlaceholder: "Select shipping service",
        dateLabel: "Date",
        selectDatePlaceholder: "Select Date",
        timeLabel: "Time",
        courierNoteLabel: "Note for courier",
        courierNotePlaceholder: "Enter note"
      },
      specialHandling: {
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        woodPacking: "Wood Packing"
      },
      address: {
        mainBadge: "Main",
        coordinate: "Coordinat points: {lat}"
      },
      addressEmpty: "Choose pick up address",
      addressListTitle: "Address list",
      recommendationLabel: "Recommended pieces and weight",
      recommendationChip: "{koli} pcs • {weight} kg",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimated pcs is required",
        weight: "Estimated weight is required",
        date: "Date is required",
        time: "Time is required",
        service: "Shipping service is required",
        address: "Pick up address is required"
      },
      changeAddress: "Change address",
      chooseAddress: "Choose address",
      timePlaceholder: "Select Pick Up time",
      back: "Back",
      retry: "Retry",
      submit: "Request",
      sttListTitle: "List of Airway Bill available for Pick Up ({count})",
      sttListEmpty: "List of Airway Bill is not available yet",
      success: {
        title: "Pick Up request sent successfully",
        message: "Pick Up will be processed by the courier shortly.",
        button: "OK, got it"
      },
      error: {
        title: "Pick Up request failed",
        message: "Please try again in a few moments.",
        button: "Close"
      }
    },
    detail: {
      header: {
        title: "Detail - {pickupId}",
        woodPacking: "WOOD"
      },
      printLabel: "Print label",
      dhlCourierNamePrefix: "[DHL Courier]",
      labelUnavailable: "Label not available yet",
      summary: {
        shared: {
          metricsKg: "{weightKg} kg",
          metricsKoliOnly: "{koliCount} pcs",
          metricsSttKoliKg: "{sttCount} AWB ({koliCount} pcs) • {weightKg} kg",
          additionalKoli: "+ Additional {additionalKoli} pcs"
        },
        totalRequest: {
          title: "Total Request"
        },
        totalPickup: {
          title: "Total Pick Up",
          additionalKoli: "Additional {additionalKoli} pcs"
        },
        agentHub: {
          title: "In Transit Hub"
        }
      },
      stt: {
        sectionTitle: "List of Airway Bill Picked Up",
        emptyTitle: "No Airway Bill list yet",
        table: {
          colNo: "No",
          colSttNo: "No. AWB",
          colKoli: "Pcs & Weight",
          colBerat: "Weight",
          weightSuffix: "{weight} kg"
        },
        pagination: {
          caption: "{shown} of {total} data"
        }
      },
      sidebar: {
        title: "Pick Up Status",
        createdAtLabel: "Created date",
        createdBy: "By {name}",
        courierSection: "Courier Information",
        courierEmpty: "Courier not yet assigned",
        proofPhotos: "Proof of Photo",
        merge: {
          infoMessage:
            "This shipment is a merge of {shipmentCount} with total pcs and weight calculated in aggregate.",
          shipmentUnit: "shipments",
          viewLink: "View shipments",
          listTitle: "List of merged shipments",
          listItem: "{shipmentId} ({koliCount} pcs - {weightKg} kg)",
          listItemIdOnly: "{shipmentId}"
        }
      },
      status: {
        waitingCourier: "Waiting for Courier",
        pickUpPackage: "Pick Up Package",
        mergedPickUp: "Merged Pick Up",
        cancelled: "Cancelled",
        done: "Done"
      }
    }
  },
  pickupAddress: {
    common: {
      primary: "Primary",
      coordinates: "Coordinates",
      select: "Select",
      delete: "Delete",
      back: "Back",
      cancel: "Cancel"
    },
    savedList: {
      title: "Saved address list",
      edit: "Edit",
      setPrimary: "Set as primary address",
      add: "Add address"
    },
    deleteConfirmation: {
      title: "Delete this address?",
      message: "You will lose this address from the saved address list."
    },
    form: {
      addTitle: "Add new address",
      editTitle: "Edit address",
      addressName: "Address name",
      addressNamePlaceholder: "Enter address name",
      picName: "PIC name",
      picNamePlaceholder: "Enter PIC name",
      phoneNumber: "Phone number",
      district: "District, city",
      districtPlaceholder: "Type or select district, city",
      pickupAddress: "Pick Up address",
      pickupAddressPlaceholder: "Enter Pick Up address",
      coordinates: "Google Maps coordinates",
      coordinatesPlaceholder: "Example: -6.18959, 106.76477",
      findLocation: "Find location",
      setPrimary: "Set as primary address",
      submit: "Submit"
    },
    guide: {
      link: "View guide",
      title: "Find location coordinates",
      openMapsPrefix: "Open",
      googleMaps: "Google Maps",
      openMapsSuffix: "on your laptop/computer.",
      searchLocation: "Search and select the Pick Up address location.",
      copyCoordinates:
        "Right-click the location, then left-click the coordinates.",
      coordinatesExample: "(Example: -6.18959, 106.76477)",
      enterCoordinates: "Enter the coordinates in the provided form."
    },
    success: {
      addedTitle: "\"{name}\" added successfully",
      editedTitle: "\"{name}\" updated successfully",
      message: "You can now use this address for Pick Up.",
      button: "OK, got it"
    }
  },
  pickupCorporate: {
    menuPickUp: "Pick Up",
    menuListPickUp: "Pick Up List",
    menuScheduleConfig: "Schedule Configuration",
    menuCreateConfig: "Create new configuration",
    menuCreatePickUp: "Create New Pick Up",
    menuEditConfig: "Edit configuration",
    buttonCreateInstant: "Create Instant Pick Up",
    searchPlaceholder: "Search shipment no.",
    periodeTitle: "Pick Up Schedule",
    filterVehicleType: "Vehicle Type",
    filterVehiclePlaceholder: "Select vehicle type",
    filterPickupType: "Pick Up Type",
    filterServiceType: "Service Type",
    emptyHeaderMessage: "No pick up list yet",
    emptyMessage: "Create an instant pick up and check the list here.",
    typeScheduled: "Scheduled Pick Up",
    typeInstant: "Instant Pick Up",
    sortLabel: "Sort by",
    sortNearest: "Nearest Pick Up schedule",
    sortFarthest: "Farthest Pick Up schedule",
    sortMaxPickup: "Highest tonnage",
    sortMinPickup: "Lowest tonnage",
    sortMaxKoli: "Highest number of pieces",
    sortMinKoli: "Lowest number of pieces",
    columnNo: "No",
    columnShipmentId: "Shipment ID",
    columnClientRef: "Client reference",
    columnSchedule: "Pick Up Schedule",
    columnVehicleType: "Vehicle type",
    columnEstKoli: "Estimated pieces",
    columnPickupType: "Pick Up Type",
    columnServiceType: "Service type",
    columnStatus: "Status",
    actualKoli: "Actual",
    koli: "pieces",
    seeAll: "(See all)",
    statusFindingCourier: "Finding Courier",
    statusCourierAssigned: "Courier Assigned",
    statusPickedUp: "Picked Up",
    statusDone: "Done",
    statusCancelledCourier: "Cancelled by Courier",
    statusCancelledClient: "Cancelled by Client",
    statusCancelledAdmin: "Cancelled by Admin",
    selectStatus: "Select Status",
    bannerNewFeatureTitle: "New feature: You can now do instant Pick Up!",
    bannerNewFeatureDesc:
      'Want your packages picked up right away? Just click "Create Instant Pick Up", fill in the Pick Up details, and you\'re done!',
    detailInfo: "Detail Information",
    the3lcPickUp: "3LC Pick Up",
    addressPickUp: "Pick Up Address",
    coordLabel: "Coordinates",
    coordLabelGoogle: "Google Maps coordinates",
    datePickUp: "Pick Up Date",
    timePickUp: "Pick Up Time",
    statusRequest: "Pick Up request status",
    cancelPickUp: "Cancel Pick Up",
    cancelButton: "Cancel",
    modalCancelTitle: "Cancel Pick Up?",
    modalCancelMessage:
      "Pick Up request will not be processed if you cancel this Pick Up.",
    modalCancelSuccessTitle: "Pick Up cancelled successfully",
    modalCancelSuccessMessage:
      'Pick Up with shipment number "{shipmentId}" has been cancelled successfully.',
    cancelFailedMessage:
      "Pick Up cancellation failed. Please check and try again.",
    copySuccess: "Shipment ID copied successfully",
    clientRef: "Client Reference",
    districtCity: "District, City",
    courierNote: "Note for courier",
    estimateKoli: "Estimated Pieces",
    actualKoliLabel: "Actual pieces",
    estimateTonase: "Estimated tonnage",
    vehicleType: "Vehicle Type",
    serviceType: "Service Type",
    proofPhoto: "Pick Up proof photo",
    photoN: "Photo {n}",
    listStt: "STT List",
    emptyStt: "No STT list yet",
    emptySttMessage:
      "Wait for your STT to be processed by Lion Parcel Agent/POS.",
    vehicleNo: "Vehicle number",
    courierName: "Courier name",
    courierPhone: "Courier contact number",
    cancelReason: "Cancellation reason",
    dateCreated: "Date Created",
    dateUpdated: "Date Updated",
    back: "Back",
    retry: "Retry",
    yesCancel: "Yes, cancel",
    titleCreate: "Create Instant Pick Up",
    placeholderClient: "Select client reference",
    placeholderCourierNote: "Enter your note for the courier",
    fleetAndSchedule: "Fleet and Schedule",
    placeholderService: "Select service type",
    placeholderTime: "Minimum 4 hours from request time",
    modalSuccessTitle: "Instant Pick Up created successfully",
    modalSuccessMessage:
      'Pick Up request with shipment number "{shipmentId}" has been created.',
    modalFailedTitle: "Instant Pick Up failed to create",
    modalFailedMessage:
      "New Pick Up schedule configuration request failed to create. Please check and try again.",
    errorTimeTitle: "Pick Up time must be at least 4 hours from now",
    errorTimeMessage: "Please adjust your Pick Up time.",
    transportType: "Vehicle Type",
    pickupDate: "Pick Up Date",
    pickupDay: "Pick Up Day",
    jamPickup: "Pick Up Time",
    save: "Save",
    ok: "OK",
    buttonCreateConfig: "Create New Configuration",
    bannerScheduleTitle:
      "New feature: You can now configure Pick Up schedules!",
    bannerScheduleDesc:
      'Want to schedule regular Pick Ups? Just click "Create new configuration", fill in the Pick Up details, and choose the repeat schedule!',
    emptyScheduleHeader: "No Schedule Configuration List",
    emptyScheduleMessage:
      "Start creating Schedule Configuration and check the list here",
    columnConfigName: "Schedule configuration name",
    dateStart: "Start Date",
    dateEnd: "End Date",
    repeatPickup: "Pick Up repetition",
    titleCreateConfig: "Create New Configuration",
    titleEditConfig: "Edit configuration",
    placeholderConfigName: "E.g.: Pick Up JABODETABEK",
    dateStartPickUp: "Pick Up start date",
    dateEndPickUp: "Pick Up end date",
    validationEndBeforeStart:
      "Pick Up end date must not be earlier than Pick Up start date",
    maxPickupTime: "Maximum Pick Up collection time 4:00 PM (MYT)",
    modalConfirmTitle: "Save Pick Up schedule configuration changes?",
    modalConfirmMessage: "Please ensure the data you entered is correct.",
    modalSuccessConfigTitleCreated: "created successfully",
    modalSuccessConfigTitleUpdated: "updated successfully",
    modalSuccessConfigCreated:
      "New Pick Up schedule configuration has been created.",
    modalSuccessConfigUpdated:
      "Pick Up schedule configuration changes have been saved.",
    modalFailedConfigMessage:
      "New Pick Up schedule configuration failed to create. Please check and try again.",
    pickupInterval: "Pick Up",
    weekOnce: "week(s)",
    hariPickup: "Pick Up Day",
    tanggalMulaiPickup: "Pick Up Start Date",
    tanggalBerakhirPickup: "Pick Up End Date",
    configName: "Schedule configuration name",
    repeatPickUpLabel: "Pick Up repetition",
    nextPickUpDay: "Next pick up on",
    statusSchedule: "Pick Up schedule status",
    statusConfig: "Schedule configuration status",
    editButton: "Edit",
    clickToActivateStatus:
      "Click the button below to activate or deactivate status",
    statusActive: "Active",
    statusInactive: "Inactive",
    filterPlaceholderClient: "Select client reference",
    filterPlaceholderVehicle: "Select vehicle type",
    utama: "Default",
    addAddress: "Add new address",
    selectOtherAddress: "Select other address",
    noAddressSaved: "No saved address yet",
    placeholderAddress: "Enter Pick Up address",
    successAddressSaved: "You can now use this address for Pick Up.",
    searchAndSelectAddress: "Search & select Pick Up address location.",
    namaAlamat: "Address name",
    namaPIC: "PIC name",
    noHP: "Phone number",
    kecamatanKota: "District, City",
    simpanAlamat: "Save address",
    placeholderNamaAlamat: "Enter address name",
    placeholderNamaPIC: "Enter PIC name",
    okeMengerti: "OK, got it",
    titleAddAddress: "Add new address",
    titleEditAddress: "Edit address",
    searchDistrictCity: "Type or select district, city",
    postalCode: "Postal code",
    placeholderPostalCode: "Enter postal code",
    placeholderCoordinate: "Example: -6.523523523523",
    successAddAddressTitle: '"{name}" added successfully',
    successEditAddressTitle: '"{name}" updated successfully',
    geoHelpText: "Having trouble finding the coordinate location?",
    geoCheckHere: "Check here.",
    geoModalTitle: "How to find location coordinates",
    savedAddressListTitle: "Saved address list",
    editAddress: "Edit address",
    selectAndSetDefault: "Select & set as default address",
    delete: "Delete",
    select: "Select",
    cancel: "Cancel",
    deleteAddressTitle: "Delete this address?",
    deleteAddressMessage:
      "You will lose this address from the saved address list.",
    placeholderEstimateTonase: "Enter estimated tonnage",
    placeholderEstimateKoli: "Enter estimated pieces",
    selecDate: "Select date",
    pickupTimeLabel: "Package will be picked up on {date} - {time}",
    modalFailedConfigTitle: '"{client}" failed to be {action}',
    updated: "updated",
    created: "created",
    repeatInterval: "Repeat every",
    repeatEvery: "Repeat on",
    week: "Week",
    weekOption: "{count} Week",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    andDay: "and {day}",
    repeatScheduleLabel: "{days} {time}, every {interval} week(s)",
    errorGetData: "Failed to retrieve data!",
    errorSystem: "An error occurred in the system. Please try again later.",
    successDeleteAddressTitle: '"{name}" deleted successfully',
    successDeleteAddressMessage: "You can add the new address again.",
    geolocation: {
      step1: "Open",
      onLaptop: "on your laptop/computer.",
      rightClickCoordinate:
        "Right-click on the location & left-click on the coordinates.",
      enterCoordinate: "Enter the coordinates into the provided form."
    },
    bookingSummary: {
      titleSuggestion: "Recommended to pick up",
      titleBucket: "Ready to pick up",
      changeAddress: "Change address",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Nearest schedule:",
      viewStt: "View STT",
      viewActivePickup: "View active Pick Up {count}",
      empty:
        "Pickup request data is unavailable. Please create the pickup manually",
      createManual: "Create Pick Up Manually",
      piece: "pcs",
      wood: "WOOD",
      addressIsEmpty: "No pick-up address has been added.",
      addAddress: "Add address"
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Create Manual Pick Up"
      },
      banner: {
        sttPrefix: "You have ",
        sttSuffix: " Airway Bill that can be processed.",
        viewAll: "View all"
      },
      field: {
        addressLabel: "Pick Up address",
        koliLabel: "Estimated pcs",
        koliPlaceholder: "Enter pcs",
        weightLabel: "Estimated weight",
        weightPlaceholder: "Enter weight",
        weightUnit: "kg",
        serviceLabel: "Shipping service",
        servicePlaceholder: "Select shipping service",
        dateLabel: "Date",
        timeLabel: "Time",
        courierNoteLabel: "Note for courier",
        courierNotePlaceholder: "Enter note"
      },
      specialHandling: {
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        woodPacking: "Wood Packing"
      },
      address: {
        mainBadge: "Main",
        coordinate: "Coordinat points: {lat}"
      },
      suggestionHint:
        "Data is filled automatically based on recommendations; you can change it.",
      addressEmpty: "Choose pick up address",
      addressListTitle: "Address list",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimated pcs is required",
        weight: "Estimated weight is required",
        date: "Date is required",
        time: "Time is required",
        service: "Shipping service is required",
        address: "Pick up address is required"
      },
      changeAddress: "Change address",
      chooseAddress: "Choose address",
      submit: "Request",
      sttListTitle: "List of Airway Bill available for Pick Up ({count})",
      sttListEmpty: "List of Airway Bill is not available yet",
      success: {
        title: "Pick Up request sent successfully",
        message: "Pick Up will be processed by the courier shortly.",
        button: "OK, got it"
      },
      error: {
        title: "Pick Up request failed",
        message: "Please try again in a few moments.",
        button: "Close"
      }
    },
    scheduleConfig: {
      pageTitle: "Set Pick Up schedule",
      breadcrumb: {
        parent: "Pick Up Schedule Configuration"
      },
      sidebar: {
        addressTitle: "Pick Up Address",
        changeAddress: "Change address",
        saveSchedule: "Save schedule",
        defaultBadge: "Primary",
        coordinatesLabel: "Coordinate point:",
        empty: "No saved address yet"
      },
      shipment: {
        sectionTitle: "Shipment Information",
        estimateAdditionalKoli: "Estimated additional pieces",
        estimateWeight: "Estimated weight",
        weightSuffix: "kg",
        serviceType: "Shipping service",
        placeholderKoli: "Enter estimated additional pieces",
        placeholderWeight: "Enter estimated weight",
        placeholderService: "Select shipping service"
      },
      scheduleSectionTitle: "Pick Up Schedule",
      regular: {
        title: "Regular schedule",
        tooltip:
          "The latest Pick Up schedule will be applied starting tomorrow.",
        maxSlotsNote: "(Max. 3 schedules per day.)",
        addTime: "Add time",
        emptySlots: "No time selected",
        popoverTitle: "Select Pick Up time",
        durationFooter: "Duration 1 hour",
        duplicateTime: "This time has already been added",
        confirmTime: "Select",
        emptyTimeOptions: "No time options available",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        }
      },
      special: {
        modalTitle: "Select Pick-up schedule",
        pickDateLabel: "Select date",
        pickTimeLabel: "Select time",
        save: "Save",
        duplicateDate: "This date has already been added",
        modalMaxSlotsNote: "Max. 3 schedules per day.",
        title: "Special schedule",
        tooltipTitle: "Special Schedule",
        tooltipDescription:
          "Special schedules will override regular schedules on the selected dates.",
        maxDatesNote: "(Max. 3 dates.)",
        addDate: "Select Pick-up date",
        reset: "Reset",
        addTime: "Add time"
      }
    }
  },
  pickupV2: {
    copyStt: "Copy STT Number",
    copiedStt: "STT number copied to clipboard",
    column: {
      sttNo: "STT No.",
      shipmentNo: "Shipment No.",
      awbAndShipment: "AWB & Shipment No.",
      lastStatus: "Last status",
      destinationCity: "Destination city",
      productType: "Shipping service",
      chargeableWeight: "Chargeable weight",
      createdAt: "Booking date",
      bookedFor: "Booked for"
    },
    list: {
      title: "Pickup List",
      createConfig: "Set Pickup Schedule",
      wood: "WOOD",
      piece: "pcs",
      additional: "Additional",
      table: {
        orderId: "Order ID",
        status: "Status",
        totalRequest: "Total requested",
        totalRequestTooltip: "Total number of pieces requested for pickup.",
        totalPickup: "Total picked up",
        totalPickupTooltip:
          "Total number of shipments and pieces that have been picked up by the courier.",
        agentHubProcessed: "Processed by Agent/Hub",
        agentHubProcessedTooltip:
          "Total number of shipments and pieces processed by the Agent/Hub.",
        createdAt: "Created at"
      },
      emptyTitle: "No Pickup List Available",
      emptyMessage: "All pickup requests will appear on this page.",
      notFountTitle: "No Results Found",
      notFountMessage:
        "Please check your keywords or try using different keywords.",
      summary: {
        pickUp: "Pick Up",
        totalLabel: "Total request",
        dateLabel: "Pick Up date",
        timeLabel: "Pick Up time"
      },
      button: {
        close: "Close",
        viewDetail: "View shipment detail",
        viewDetailAWB: "View detail"
      }
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Create Manual Pick Up"
      },
      banner: {
        sttPrefix: "You have ",
        sttSuffix: " that can be processed.",
        viewAll: "View all"
      },
      field: {
        addressLabel: "Pick Up address",
        koliLabel: "Estimated pcs",
        koliPlaceholder: "Enter pcs",
        weightLabel: "Estimated weight",
        weightPlaceholder: "Enter weight",
        weightUnit: "kg",
        serviceLabel: "Shipping service",
        servicePlaceholder: "Select shipping service",
        dateLabel: "Date",
        timeLabel: "Time",
        courierNoteLabel: "Note for courier",
        courierNotePlaceholder: "Enter note"
      },
      specialHandling: {
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        woodPacking: "Wood Packing"
      },
      address: {
        mainBadge: "Main",
        coordinate: "Coordinat points: {lat}"
      },
      addressEmpty: "Choose pick up address",
      addressListTitle: "Address list",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimated pcs is required",
        weight: "Estimated weight is required",
        date: "Date is required",
        time: "Time is required",
        service: "Shipping service is required",
        address: "Pick up address is required",
        client: "Client is required",
        clientLoadFailed:
          "Failed to load client details. Please select the client again."
      },
      changeAddress: "Change address",
      chooseAddress: "Choose address",
      addAddress: "Add address",
      submit: "Request",
      sttListTitle: "List of Airway Bill available for Pick Up ({count})",
      sttListEmpty: "List of Airway Bill is not available yet",
      success: {
        title: "Pick Up request sent successfully",
        message: "Pick Up will be processed by the courier shortly.",
        button: "OK, got it"
      },
      error: {
        title: "Pick Up request failed",
        message: "Please try again in a few moments.",
        button: "Close"
      }
    },
    detail: {
      header: {
        title: "Detail - {pickupId}"
      },
      pageTitle: "Pickup List | Detail",
      summary: {
        shared: {
          sttUnit: "AWB",
          koliUnit: "pcs",
          weightUnit: "kg",
          additionalLabel: "+ Additional"
        },
        totalRequest: {
          title: "Total Request"
        },
        totalPickup: {
          title: "Total Pick Up"
        },
        agentHub: {
          title: "In Transit Hub"
        }
      },
      stt: {
        sectionTitle: "List of Airway Bill Picked Up",
        table: {
          colNo: "No",
          colSttNo: "No. AWB",
          colKoli: "Pcs & Weight",
          colBerat: "Weight",
          weightSuffix: "{weight} kg"
        },
        pagination: {
          caption: "{shown} of {total} data"
        }
      },
      sidebar: {
        title: "Pick Up Status",
        createdAtLabel: "Created date",
        createdBy: "By {name}",
        courierSection: "Courier Information",
        courierEmpty: "Courier not yet assigned",
        proofPhotos: "Proof of Photo",
        merge: {
          infoMessage:
            "This shipment is a merge of {shipmentCount} with total pcs and weight calculated in aggregate.",
          shipmentUnit: "shipments",
          viewLink: "View shipments",
          listTitle: "List of merged shipments",
          listItem: "{shipmentId} ({koliCount} pcs - {weightKg} kg)",
          listItemIdOnly: "{shipmentId}"
        }
      },
      status: {
        waitingCourier: "Waiting for Courier",
        pickUpPackage: "Pick Up Package",
        mergedPickUp: "Merged Pick Up",
        pickUpCompleted: "Pick Up Completed",
        processedAgentHub: "Processed by Agent/Hub"
      },
      filter: {
        searchPlaceholder: "Search Order ID",
        pickupSchedule: "Pickup Schedule",
        vehicleType: "Vehicle Type",
        vehicleTypePlaceholder: "Select vehicle type",
        serviceType: "Service Type",
        status: "Status",
        statusPlaceholder: "Select status",
        statusList: {
          searchingCourier: "Searching for Courier",
          courierAssigned: "Courier Assigned",
          packagePickedUp: "Package Picked Up",
          completed: "Completed",
          cancelledByCourier: "Cancelled by Courier",
          cancelledByClient: "Cancelled by Client",
          cancelledByAdmin: "Cancelled by Admin"
        }
      },
      requestInfo: {
        sectionTitle: "Pick Up Request Detail",
        warehousePrefix: "Warehouse",
        coordinateLabel: "Coordinate point: {coordinate}",
        courierNoteLabel: "Notes for courier",
        courierNoteEmpty: "-"
      },
      printLabel: "Print label",
      dhlCourierNamePrefix: "[DHL Courier]",
      labelUnavailable: "Label not available yet"
    },
    modalSttPickupList: {
      title: "List of STTs Available for Pickup ({bkdCount})",
      searchPlaceholder: "Search STT",
      totalCount: "{count} STTs",
      empty: {
        title: "No STTs Available for Pickup",
        message: "There are no STTs to display."
      },
      notFound: {
        title: "No Results Found",
        message: "Check your keyword or try a different search term."
      },
      copyStt: "Copy STT Number",
      copiedStt: "STT number copied to clipboard",
      column: {
        sttNo: "STT No.",
        shipmentNo: "Shipment No.",
        lastStatus: "Latest Status",
        destinationCity: "Destination City",
        productType: "Shipping Service",
        chargeableWeight: "Chargeable Weight",
        createdAt: "Booking Date",
        bookedFor: "Booked For"
      }
    },
    detailSidebar: {
      statusPickUp: "Pick Up Status",
      createdAt: "Created date",
      by: "By {name}",
      courierInfo: "Courier information",
      courierNotAssigned: "Courier not yet assigned",
      proofPhotos: "Proof photos",
      courierName: "Courier name",
      revealPhone: "Show phone number",
      sidebar: {
        merge: {
          infoMessage:
            "This shipment is merged from <strong>{shipmentCount}<strong>, with the total pieces and weight calculated together.",
          shipmentUnit: "shipments",
          viewLink: "View shipments",
          listTitle: "Merged shipment list",
          listItem: "{shipmentId} ({koliCount} pcs - {weightKg} kg)",
          close: "Close"
        }
      }
    }
  },
  bookingV4: {
    breadcrumb: {
      retailBooking: "Retail Booking"
    },
    pageTitle: "Create Booking",
    pageTitleEdit: "Edit Booking",
    bookingHistory: "Booking History",
    bookingHistorySuccessTitle: "Successful Booking History ({counter})",
    reset: "Reset",
    cancelVoucher: "Cancel Voucher",
    reserveVoucher: "Reserve Voucher",
    header: {
      bookingHistory: {
        button: "Print Bill & Receipt"
      },
      receiptFormat: {
        a4: "A4 Label",
        a6: "A6 Label",
        none: "No Label Print",
        title: "Receipt Format"
      },
      tabs: {
        domestic: "Domestic",
        international: "International"
      }
    },
    detailSender: "Sender detail",
    detailRecipient: "Receiver detail",
    name: "Name",
    phoneNumber: "Phone Number",
    edit: "Edit",
    address: "Address",
    districtCity: "District, City",
    postalCode: "Postal Code",
    office: "Office",
    autofill: "Copy & Autofill",
    sender: {
      title: "Sender",
      name: {
        placeholder: "Enter name",
        error: {
          required: "Name required",
          minLength: "Name minimum of 3 characters",
          notFound: "Customer data not found"
        }
      },
      phone: {
        placeholder: "Enter phone number",
        error: {
          required: "Phone number required",
          invalid: "Invalid phone number",
          notFound: "Customer data not found",
          fraud: {
            limited1: "This number has reached the daily COD/DFOD",
            limited2: "transaction limit.",
            limited3: "",
            limitedTooltip:
              "Phone numbers are limited to a max. of 10 COD/DFOD air waybill (excluding CNX) or a total shipping cost of RM28.1",
            suspected: "This number has a high COD/DFOD return rate"
          }
        }
      },
      address: {
        placeholder: "Enter address",
        error: {
          required: "Address required",
          minLength: "Address minimum of 3 characters",
          sameAddress: "The sender and recipient addresses cannot be the same"
        }
      }
    },
    recipient: {
      title: "Recipient",
      country: {
        placeholder: "Enter & select destination country",
        error: {
          required: "Destination country required",
          notFound: "Country not found"
        }
      },
      name: {
        placeholder: "Enter name",
        error: {
          required: "Name required",
          minLength: "Name minimum of 3 characters",
          notFound: "Customer data not found"
        }
      },
      phone: {
        placeholder: "Enter phone number",
        error: {
          required: "Phone number required",
          invalid: "Invalid phone number",
          notFound: "Customer data not found"
        }
      },
      address: {
        placeholder: "Enter address",
        error: {
          required: "Address required",
          minLength: "Address minimum of 3 characters",
          sameAddress: "The sender and recipient addresses cannot be the same"
        }
      },
      city: {
        placeholder: "Enter & select city, region",
        labelAlternate: "City, Region",
        error: {
          required: "City, region required",
          notFound: "City, region not found",
          routeNotAvailable: "Route is not available"
        },
        misbookingGuidance:
          "This destination is prone to misdelivery. Make sure the selection matches the recipient's address."
      },
      postalCode: {
        placeholder: "Enter & select postal code",
        error: {
          required: "Postal code required",
          notFound: "Postal code not found"
        }
      }
    },
    optional: "Optional",
    additionalPhoto: "Supporting Photos",
    beforeAfterPackingPhoto: "Photos before & after packing",
    packageBeforePacking: "Package before packing",
    packageAfterPacking: "Package after packing",
    recipientIdNumber: "Receiver ID number",
    recipientIdPhoto: "Receiver ID Photo",
    recipientTaxIdNumber: "Receiver Tax ID number",
    recipientTaxIdPhoto: "Receiver Tax ID Photo",
    doc: {
      title: "International Shipping Supporting Documents",
      titleFTZ: "Free Trade Zone supporting documents",
      subtitle: "Supporting Documents",
      guide: {
        title: "Supporting document guide",
        expand: "Show",
        collapse: "Close",
        content: `<ul class="custom-list">
          <li>Use <span class="font-bold">JPG, JPEG, PNG, or PDF</span> format (max. 5 MB/file).</li>
          <li>Make sure the <span class="font-bold">brand of the item</span> is clearly visible in the photo before packing.</li>
          <li>Ensure photos are <span class="font-bold">clear and complete</span> to speed up the verification process.</li>
          <li>You can add up to <span class="font-bold">5 additional supporting documents</span> (e.g., import permits, circulars, etc.). Check <a target="_blank" rel="noopener noreferrer" class="underline font-bold" href="https://lionparcel.com/sk">t&c</a> details</li>
        </ul>`
      },
      email: {
        label: "Recipient Email",
        placeholder: "Enter recipient email",
        errorRequired: "Email required",
        errorInvalid: "Invalid email"
      },
      idNumber: {
        label: "Recipient Identity Number",
        placeholder: "Enter recipient identity number",
        errorRequired: "Identity number required",
        errorInvalid: "Identity number may only contain letters and numbers"
      },
      taxNumber: {
        label: "Recipient Tax ID",
        placeholder: "Enter recipient tax ID",
        errorRequired: "Tax ID required",
        errorInvalid: "Tax ID may only contain letters and numbers"
      },
      dutyTaxTerms: {
        label: "Customs & Tax Payment",
        dap: "Paid by Recipients (DAP)",
        ddp: "Paid by Shipper (DDP)",
        placeholder: "Select the paying party",
        infoCopy: `<ul class="custom-list">
          <li><span class="font-bold">Delivered Duty Paid (DDP):</span> The shipper will cover all customs duties and taxes.</li>
          <li><span class="font-bold">Delivery At Place (DAP):</span> The recipient will cover all customs duties and taxes when the package arrives at its destination.</li>
        </ul>`,
        dutyTaxTermsBannerPrefix:
          "If there are Customs Duty & Tax charges, they will be charged to",
        shipper: "Sender",
        recipient: "Receiver",
        errorRequired: "Paying party must be selected"
      },
      upload: {
        idCard: "Identity Card",
        taxCard: "Tax ID Card",
        beforePacking: "Package Before Packing",
        afterPacking: "Package After Packing",
        additional: "Add Other Supporting Document",
        additionalDocument: "Additional <br>document",
        limitMessage:
          "Maximum of 5 additional files (JPG/JPEG/PNG/PDF, max 5 MB)",
        errorRequired: "Required.",
        uploadFailed: "Failed to upload document. Please try again.",
        error:
          "Invalid file format or exceeds 5 MB. Use JPG, JPEG, PNG, or PDF."
      }
    },
    referenceNumber: {
      title: "Reference Number",
      placeholder: "Enter reference numbers, separated by Enter or Comma",
      helperText:
        "Enter the External ID/STT Manual/Shipment ID so the order can be tracked using that number.",
      maxLimit: "Maximum {max} reference numbers reached",
      duplicateType: "This reference type has already been added",
      type: {
        sttManual: "STT Manual",
        shipmentId: "Shipment ID",
        externalRef: "External Reference"
      },
      error: {
        externalRequired: "Reference number required",
        selectClientFirst:
          "Please select a Client first before entering Manual STT"
      }
    },
    reference: {
      error: {
        required: "Required"
      }
    },
    goods: {
      title: "Goods & Packages",
      button: {
        reset: "Reset"
      },
      itemDetails: {
        title: "Item Details"
      },
      cipl: {
        title: "Detail Goods (CIPL)",
        itemName: "Item Name",
        quantity: "Quantity",
        unitPrice: "Unit Price",
        totalPrice: "Total Price",
        footerTotal: "Total Goods Price",
        footerEstimated: "(Est. {currency} {amount})",
        addRow: "Add",
        deleteRow: "Delete",
        otherCommodity: "Other",
        placeholder: {
          itemName: "Select item",
          quantity: "Enter Quantity",
          unitPrice: "Enter Unit Price"
        },
        deminimisWarning:
          "This shipment will be subject to duty and tax as it exceeds the de minimis threshold of {currency}{amount}.",
        importDocWarning:
          "The recipient is required to handle the customs clearance and import documentation process in the destination country.",
        selfClearanceWarning:
          "Please inform the sender that the recipient must handle the customs clearance process for this shipment in the destination country.",
        error: {
          itemDetailMandatory: "Item name must be filled in",
          quantityMandatory: "Must be filled",
          goodsPriceMandatory: "Price must be filled in"
        }
      },
      commodity: {
        title: "Commodity",
        placeholder: "Select commodity",
        viewAll: "View All",
        notFound: "Commodity not found",
        note: "Note",
        tnc: "Terms & Conditions",
        tncBody: "Fill in the commodity according to the T&C.",
        recommendationError: "Failed to load recommendations",
        errorRequired: "Commodity must be selected",
        errorInactive: "Commodity is inactive",
        modal: {
          searchResult: "Search Results",
          searchPlaceholder: "Enter or select commodity",
          mostUsed: "Most Used",
          emptySearch: "Result not found",
          emptySearchDescription: "Check and try other keywords",
          emptyCategory: "Enter a keyword or select a category",
          reload: "Reload"
        }
      },
      koli: {
        title: "Package Weight",
        grossWeight: "Gross Weight (kg)",
        dimensions: "Dimensions (cm)",
        length: "L",
        width: "W",
        height: "H",
        volumeWeight: "Volume Weight",
        button: {
          add: "Add Package",
          delete: "Delete"
        },
        alert: {
          hws:
            "A surcharge will apply for weights over {minimumWeightKg} kg, and you cannot add more packages."
        },
        error: {
          hwsSecondRow:
            "Weights above {minimumWeightKg} kg are allowed only for one package.",
          districtOnePiece:
            "The destination district/city only allows a maximum of 1 package.",
          adjustWeight: "Weight loss changes are not permitted"
        },
        infobarWeightComma: "For weight < 1 kg use (,). Example: 0.5 kg."
      },
      uploadWeight: {
        title: "Required to upload photo proof of item to change weight",
        showGuide: "View guide",
        closeGuide: "Close guide",
        sampleBadge: "SAMPLE PHOTO",
        addPhoto: "Add Photo",
        guideScalePhoto: "Scale photo",
        guidePackageIdentityPhoto: "Item photo with identity",
        additionalPhoto: "Additional photo",
        guides: {
          resolutionBold: "Photo resolution",
          resolutionText: "is clear and not blurry.",
          scaleBold: "Scale",
          scaleOrText: "or",
          volumeBold: "volume measurement",
          volumeText: "is clearly visible.",
          labelSttBold: "STT label, shipment,",
          labelSttText: "or other labels can be read.",
          wholePackageBold: "Entire package",
          wholePackageText: "is visible in one photo."
        },
        error:
          "Please upload at least two photos of the weighing proof to change the weight of this STT."
      },
      savedPackage: {
        commodity: "Commodity",
        totalPieces: "Total pieces",
        grossWeight: "Gross weight",
        checkbox: {
          label: "Save (Max. 3 saved package data. New data will replace old data if limit exceeded)."
        },
        tooltip: {
          title: "Detail",
          dimensionHeader: "Dimensions (L x W x H)",
          weightHeader: "Gross weight",
          dimensionValue: "{length} x {width} x {height} cm",
          weightValue: "{weight} kg",
          totalWeight: "Total Gross Weight"
        }
      }
    },
    supportingDoc: {
      error: {
        required: "Supporting document is required"
      }
    },
    cashback: "Cashback",
    shippingEstimation: "Delivery Estimation",
    shippingProduct: "Shipping Product",
    agentDiscount: "Agent Discount",
    product: {
      discount: "Discount",
      price: "Price",
      sla: "{sla} days",
      starTooltip: "Recommended",
      title: "Shipping Service",
      infoPrice: "The price does not include",
      otherPrice: "other fees",
      infoTariff: ", check total price in the summary!",
      tooltip: {
        title: "Other fees (if applicable):",
        priceMsg: `<ul class="px-2 py-4">
        <li>• Commodity surcharge</li>
        <li>• Weight surcharge</li>
        <li>• Document surcharge</li>
        <li>• Protection fee</li>
        <li>• Protection admin fee</li>
        <li>• COD fee</li>
        <li>• Woodpacking surcharge</li>
      </ul>`
      },
      infobar:
        "The price does not include other fees, check total price in the summary!",
      otherFeesDetail:
        "Other fees (if applicable): Commodity surcharge, Weight surcharge, Document surcharge, Wooden packing fee, Protection fee, Protection admin fee, COD fee",
      unavailable: "Not available",
      embargo: "Embargo",
      discountAgent: "Discount",
      discountAgentToggle: "Agent Discount",
      discountAgentPercent: "Agent Discount {percent}%",
      minWeightNote: "*Price applies to min. 10 kg",
      sectionSubtitle:
        "Total shipping cost will adjust based on selected additional services.",
      error: {
        title: "A system issue occurred",
        subtitle: 'Click "Reload" to refresh the page.',
        retry: "Reload"
      }
    },
    // GENESIS-19573 detailing's localization table lists a flat "bookingV4.vippack"
    // string alongside nested "bookingV4.vippack.badge/.discountBadge/.termsLink",
    // which can't coexist as one JS key. Nested as "label" instead — use
    // $t("bookingV4.vippack.label"), not $t("bookingV4.vippack").
    vippack: {
      label: "VIPPACK",
      badge: "VIPPACK Active",
      discountBadge: "Agent Discount {discount}%",
      termsLink: "Terms & Conditions"
    },
    formCompletion: {
      title: "Completion status",
      status: {
        complete: "Complete",
        incomplete: "Incomplete"
      },
      field: {
        required: "Required",
        optional: "Optional"
      }
    },
    otpCode: "OTP Code",
    sendOtp: "Send OTP",
    verify: "Verify",
    voucher: {
      apply: "Claim",
      sectionTitle: "Voucher",
      inputTitle: "Voucher code",
      seeMore: "View more",
      placeholder: "Enter voucher code",
      bannerOtp: "OTP required for this voucher.",
      tnc: "t&c",
      modalTitle: "Voucher",
      clearCode: "Clear voucher code",
      close: "Close",
      loading: "Loading vouchers...",
      emptyTitle: "Voucher not available",
      emptyDescription: "Voucher will be shown in here",
      completeRequired: "Complete the booking details to view vouchers",
      appliedSuccess: "Claim voucher successfully.",
      card: {
        percentage: "{value}% Discount Up to {max}",
        nominal: "{amount} Discount",
        description: "Min. transaction {minimum} until {endDate}",
        thousand: "{value}K",
        million: "{value}M"
      },
      terms: {
        title: "Terms & conditions:",
        minimum: "Minimum transaction {amount}.",
        productTypes: "Valid for shipment types: {types}.",
        serviceTypes: "Valid for delivery services: {types}.",
        usageLimit: "The voucher can be used up to {count} times per customer.",
        validUntil: "Voucher is valid until {date}.",
        percentageDiscount: "Enjoy a {value}% discount up to {maximum}.",
        nominalDiscount: "Enjoy a discount of {amount}."
      },
      otp: {
        title: "Enter OTP code",
        description:
          "Please check the OTP code sent via SMS to the shipper's number.",
        resend: "Resend OTP",
        resendCountdown: "Resend OTP code in {countdown}",
        notReceived: "Didn't receive the code?",
        continueWithoutVoucher: "Continue without voucher",
        error: {
          invalid: "Invalid OTP code. Please try again."
        }
      },
      error: {
        minTransaction: "Minimum transaction {amount}",
        invalid: "The voucher unavailable.",
        expired: "Voucher code expired",
        quotaExhausted: "Voucher limit reached."
      }
    },
    payment: {
      title: "Choose payment",
      cash: "Cash",
      cod: "COD",
      dfod: "DFOD",
      invoiceLimit: "Invoice limit",
      tooltip: {
        cod: "COD is only available for domestic shipments in select areas.",
        dfod:
          "DFOD is only available for corporate shippers or authorized agents."
      },
      disable: {
        destination: "COD/DFOD not available at destination city.",
        partner: "COD/DFOD not available for partner.",
        client: "COD/DFOD not available for partner.",
        dailyLimit: "Sender has reached the COD/DFOD transaction limit",
        blacklist: "Sender cannot use COD/DFOD",
        generic: "Sender cannot use COD/DFOD",
        invoiceLimitFrozen: "Billing limit is temporarily unavailable.",
        phoneNumberBlacklist: "COD/DFOD not available, contact our CS.",
        phoneNumberLimit: "Shipper exceeded COD/DFOD limit."
      },
      warning: {
        suspected: "This number has a high COD/DFOD return rate"
      }
    },
    protection: {
      checkbox: "Protection",
      alreadyProtected: "Shipping is protected",
      agentDiscount: "Agent Discount",
      tooltip: "Shipping protection fee: Tier 1: ...",
      itemPrice: {
        title: "Item Price",
        placeholder: "Enter good price",
        error: "Item price is required.",
        errorMax: "Maximum item price {value}",
        errorMin: "Minimum item price {value}"
      }
    },
    chargeableWeight: {
      title: "Weight details",
      grossWeight: "Total gross weight",
      volumeWeight: "Total volume weight",
      woodpacking: "Wood packing additional weight",
      final: "Final chargeable weight"
    },
    totalKoli: {
      format: "({n} packages)"
    },
    // GENESIS-20108 TotalTarifSectionV4 + tariff breakdown dropdown
    footer: {
      bookingAction: "Booking",
      totalTariff: "Total tariff",
      recipientPayable: "Amount payable by recipient",
      detailTitle: "Payment details",
      empty: "Tariff is not available yet",
      publishShippingRate: "Publish rate + shipping surcharge",
      originForwardRate: "Origin forward rate",
      destinationForwardRate: "Destination forward rate",
      shippingCost: "Shipping cost",
      commoditySurcharge: "Commodity surcharge",
      heavyweightSurcharge: "Heavyweight surcharge",
      documentSurcharge: "Document surcharge",
      totalAdditionalSurcharge: "Total additional surcharge",
      protection: "Protection",
      protectionBasic: "Basic",
      protectionFree: "Free",
      woodpacking: "Wood Packing",
      woodpackingIncluded: "Includes wood packing surcharge",
      insuranceAdminFee: "Insurance administration fee",
      codGoodsPrice: "COD goods price",
      codFee: "COD fee",
      codReturnFee: "Return fee",
      dfodShippingCod: "DFOD shipping COD fee",
      taxEstimation: "Tax estimation",
      totalAfterVoucher: "Total tariff after voucher",
      discountLabel: "Discount {value}",
      promoBadge: "Promo {value}%",
      promo: {
        tactical: "Tactical promo",
        campaign: "Campaign promo"
      },
      voucher: "Voucher promo",
      refresh: "Refresh",
      error: "Failed to load tariff"
    },
    completeForm: "Please complete all fields",
    validationError: "Form Validation Failed",
    error: {
      limitTagihanInsufficient:
        "Billing limit is insufficient for this transaction"
    },
    success: {
      title: "Booking Success",
      close: "Close",
      printInvoice: "Print Invoice",
      printReceipt: "Print Label",
      copy: "Copy",
      recipient: "Recipient",
      destination: "Destination district, city",
      serviceType: "Service type",
      estimation: "Estimated delivery",
      codFee: "COD Fee",
      dfodFee: "DFOD Fee",
      payableByReceiver: "Payable by receiver",
      totalTariff: "Total tariff",
      discount: "Discount",
      pieces: "pieces"
    },
    client: {
      label: "Client",
      fieldPlaceholder: "Select client",
      openList: "View client",
      clear: "Clear client",
      required: "Client name required",
      searchPlaceholder: "Enter & select client branch name/alias/code",
      originPlaceholder: "Enter & select client origin city (3LC)",
      originNotFound: "What you are looking for was not found.",
      serviceTypePlaceholder: "Select shipping service type",
      reset: "Reset",
      emptyInitial: "No branch clients registered",
      emptyFiltered:
        "Branch client not found. Try changing the filter or keyword.",
      notFound: "Data not found.",
      notFoundTitle: "Client search not found",
      notFoundSubtitle: "Check the keyword and try again.",
      listError: "Failed to load client list.",
      retry: "Retry",
      filter: {
        title: "Client search filter",
        originLabel: "Client origin city (3LC)",
        serviceTypeLabel: "Shipping service type"
      },
      list: {
        title: "Client list",
        close: "Close client list",
        clientName: "Client name",
        clientAlias: "Alias",
        clientOrigin: "Origin city",
        clientType: "Client type",
        serviceType: "Shipment service",
        clientCode: "Client code"
      }
    },
    previewInvoice: {
      title: "Preview Create Invoice",
      totalStt: "Total STT",
      totalTariff: "Total Tariff",
      totalInvoice: "Total Amount",
      billedTo: "Billed To",
      billedToPlaceholder: "Select billing target",
      note: "Note",
      notePlaceholder: "Enter note for invoice recipient",
      sendTo: "Send To",
      invoiceFormat: "Invoice format",
      formatPlaceholder: "Select format",
      cancel: "Cancel",
      createInvoice: "Create Invoice",
      errorGetHistory: "Failed to retrieve successful booking history data!",
      errorCreateInvoice: "Failed to create invoice!",
      options: {
        pdfA4: "PDF (A4)",
        pngA4: "PNG (A4)",
        pdfStruk: "PDF (Receipt Size)"
      }
    },
    savedAddress: {
      title: "Select detail item saved"
    } // savedAddress Close
  },
  bookingV3: {
    receiverDestinationCity: {
      misbookingGuidance:
        "This destination is prone to misdelivery. Make sure the selection matches the recipient's address."
    }
  }
};
